(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("moment"), require("moment-timezone"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "moment", "moment-timezone"], factory);
	else if(typeof exports === 'object')
		exports["Decorator"] = factory(require("underscore"), require("moment"), require("moment-timezone"));
	else
		root["Decorator"] = factory(root["underscore"], root["moment"], root["moment-timezone"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_22__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  Address: __webpack_require__(1),
	  Contacts: __webpack_require__(3),
	  Facebook: __webpack_require__(4),
	  Filters: __webpack_require__(10),
	  Interactions: __webpack_require__(14),
	  Lists: __webpack_require__(19),
	  MyPortfolio: __webpack_require__(20),
	  MyTrips: __webpack_require__(21),
	  Notifications: __webpack_require__(23),
	  Org: __webpack_require__(24),
	  Profile: __webpack_require__(16),
	  Search: __webpack_require__(25),
	  Schema: __webpack_require__(18),
	  User: __webpack_require__(26),
	  Work: __webpack_require__(17),
	  Enrichment: __webpack_require__(27),
	  Relationships: __webpack_require__(28),
	  Giving: __webpack_require__(30)
	};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var Address, _;

	_ = __webpack_require__(2);

	Address = function() {
	  var _formatObject, _getAddressByType, _getValidAddresses, _isValidAddress, _sortAddresses, api;
	  _isValidAddress = function(address) {
	    var ref, ref1, ref2, ref3;
	    return (address != null ? (ref = address.city) != null ? ref.value : void 0 : void 0) || (address != null ? (ref1 = address.state) != null ? ref1.value : void 0 : void 0) || (address != null ? (ref2 = address.country) != null ? ref2.value : void 0 : void 0) || (address != null ? (ref3 = address.zip_code) != null ? ref3.value : void 0 : void 0);
	  };
	  _getAddressByType = function(addresses, type) {
	    return _.filter(addresses, function(address) {
	      var ref, ref1, ref2;
	      return _isValidAddress(address) && (address != null ? (ref = address.type) != null ? (ref1 = ref.value) != null ? (ref2 = ref1.toLowerCase()) != null ? ref2.match(RegExp("^" + type)) : void 0 : void 0 : void 0 : void 0);
	    });
	  };
	  _getValidAddresses = function(addresses) {
	    return _.filter(addresses, function(address) {
	      return _isValidAddress(address);
	    });
	  };
	  _formatObject = function(address) {
	    var address_object;
	    address_object = {};
	    _.each(address, function(part) {
	      return address_object[part.name] = part.value;
	    });
	    return address_object;
	  };
	  _sortAddresses = function(addresses) {
	    if (!addresses) {
	      return;
	    }
	    return _.sortBy(addresses, function(a, b) {
	      var ref, ref1, ref2, ref3, ref4, return_val;
	      return_val = 0;
	      if ((ref = a.type) != null ? (ref1 = ref.value) != null ? (ref2 = ref1.toLowerCase()) != null ? ref2.match(/^home/) : void 0 : void 0 : void 0) {
	        return_val = -1;
	      } else if ((ref3 = b.type) != null ? (ref4 = ref3.value.toLowerCase()) != null ? ref4.match(/^home/) : void 0 : void 0) {
	        return_val = 1;
	      }
	      return return_val;
	    });
	  };
	  return api = {
	    getAddresses: function(parsed_contact) {
	      return _sortAddresses(_getValidAddresses(parsed_contact.addresses));
	    },
	    getPrimary: function(parsed_contact) {
	      var addresses, home, primary;
	      if (!parsed_contact) {
	        return;
	      }
	      addresses = parsed_contact.addresses;
	      primary = _.find(addresses, function(address) {
	        var ref;
	        return _isValidAddress(address) && (address != null ? (ref = address.primary) != null ? ref.value : void 0 : void 0);
	      });
	      home = _.first(_getAddressByType(addresses, "home"));
	      return primary || home || _.first(_getValidAddresses(addresses));
	    },
	    getLastLineFormat: function(address) {
	      var data, line;
	      data = _formatObject(address);
	      line = data.city ? data.city + ", " : "";
	      if (data.state) {
	        line += data.state + " ";
	      }
	      if (data.zip_code) {
	        line += data.zip_code + " ";
	      }
	      if (data.country) {
	        line += data.country + " ";
	      }
	      return line.trim();
	    },
	    isValidAddress: function(address) {
	      return _isValidAddress(address);
	    },
	    hasValidAddress: function(parsed_contact) {
	      return _.some(parsed_contact.addresses, function(address) {
	        return _isValidAddress(address);
	      });
	    }
	  };
	};

	module.exports = Address();


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var Contact, _;

	_ = __webpack_require__(2);

	Contact = function() {
	  var _getFullName, _isObjectList, _parseObject, _toPropLookup, api;
	  _toPropLookup = function(properties) {
	    var lookup;
	    lookup = {};
	    _.each(properties, function(prop) {
	      return lookup[prop.name] = prop;
	    });
	    return lookup;
	  };
	  _parseObject = function(obj) {
	    if (!_.isEmpty(obj.properties)) {
	      return _toPropLookup(obj.properties);
	    }
	  };
	  _isObjectList = function(item) {
	    var check;
	    check = _.isArray(item) ? _.first(item) : item;
	    return check && check.object_type;
	  };
	  _getFullName = function(parsed_contact) {
	    var name_first, name_last, ref, ref1, ref2, ref3, ret;
	    if (parsed_contact == null) {
	      parsed_contact = {};
	    }
	    name_first = (ref = parsed_contact.properties) != null ? (ref1 = ref.name_first) != null ? ref1.value : void 0 : void 0;
	    name_last = (ref2 = parsed_contact.properties) != null ? (ref3 = ref2.name_last) != null ? ref3.value : void 0 : void 0;
	    ret = (name_first || "") + " " + (name_last || "");
	    return ret.trim();
	  };
	  return api = {
	    parseList: function(contact_list_json) {
	      var contacts;
	      if (contact_list_json == null) {
	        contact_list_json = {};
	      }
	      contacts = _.map(contact_list_json.items, (function(_this) {
	        return function(contact) {
	          return _this.parse(contact);
	        };
	      })(this));
	      return _.extend({}, contact_list_json, {
	        items: contacts
	      });
	    },
	    parse: function(contact_json) {
	      var full_name, person, properties, ref, ref1;
	      properties = _.isArray(contact_json != null ? contact_json.items : void 0) ? _.first(contact_json.items) : contact_json;
	      person = {
	        customs: {}
	      };
	      _.each(properties, function(value, key) {
	        var parsed_customs, props, ref, ref1;
	        person[key] = value;
	        if (_isObjectList(value)) {
	          if (key === "properties") {
	            return person[key] = _toPropLookup(value);
	          } else if (_.isArray(value)) {
	            props = (ref = _.first(value)) != null ? ref.properties : void 0;
	            if (!(props != null ? (ref1 = props[0]) != null ? ref1["default"] : void 0 : void 0) && !_.isEmpty(props)) {
	              parsed_customs = _.map(value, function(obj) {
	                return _parseObject(obj);
	              });
	              person.customs[key] = parsed_customs;
	              return person[key] = parsed_customs;
	            } else {
	              person[key] = _.map(value, function(obj) {
	                return _parseObject(obj);
	              });
	              if (_.every(person[key], _.isUndefined)) {
	                return person[key] = "private";
	              }
	            }
	          } else {
	            return person[key] = _parseObject(value);
	          }
	        }
	      });
	      if (!_.isEmpty((ref = person.extended) != null ? ref.profile_image_url : void 0)) {
	        person.avatar = (ref1 = person.extended) != null ? ref1.profile_image_url : void 0;
	      }
	      full_name = _getFullName(person);
	      return _.extend({}, person, {
	        name: full_name
	      });
	    },
	    getFullName: function(parsed_contact) {
	      if (parsed_contact == null) {
	        parsed_contact = {};
	      }
	      return _getFullName(parsed_contact);
	    },
	    getDetailedName: function(parsed_contact, options) {
	      var names, output;
	      if (options == null) {
	        options = {};
	      }
	      names = {};
	      _.each(parsed_contact.properties, function(prop, key) {
	        return names[key] = prop.value;
	      });
	      output = "";
	      if (names.name_prefix && options.include_prefix) {
	        output = names.name_prefix + " ";
	      }
	      if (names.name_first) {
	        output += names.name_first + " ";
	      }
	      if (names.name_middle && options.include_middle) {
	        output += (names.name_middle || "") + " ";
	      }
	      if (names.name_nick && (names.name_nick !== names.name_first)) {
	        output += "\"" + names.name_nick + "\" ";
	      }
	      if (names.name_maiden && (names.name_maiden !== names.name_last)) {
	        output += "(" + names.name_maiden + ") ";
	      }
	      if (names.name_last) {
	        output += "" + names.name_last;
	      }
	      if (names.name_suffix) {
	        output += ", " + names.name_suffix;
	      }
	      return output || "";
	    },
	    getClassYear: function(parsed_contact) {
	      var ref, ref1;
	      if (parsed_contact != null ? (ref = parsed_contact.properties) != null ? (ref1 = ref.year) != null ? ref1.value : void 0 : void 0 : void 0) {
	        return "Class of " + parsed_contact.properties.year.value;
	      } else {
	        return "";
	      }
	    }
	  };
	};

	module.exports = Contact();


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var Facebook, Parameter, Property, Query;

	Query = __webpack_require__(5);

	Parameter = __webpack_require__(6);

	Property = __webpack_require__(8);

	Facebook = function() {
	  var api;
	  return api = {
	    getRecentEngagementsQuery: function(contact_id, type) {
	      return Query([
	        Parameter("must", [
	          Property("contact_id", contact_id, {
	            type: "equals"
	          }), Property("engagement.type", type, {
	            type: "equals"
	          }), Property("network", "facebook", {
	            type: "equals"
	          })
	        ]), Parameter("sort", [
	          Property("engagement.created_at", {
	            order: "desc"
	          }, {
	            type: "object"
	          })
	        ])
	      ]);
	    },
	    getRecentEngagementsQueryJSON: function(contact_id, type) {
	      var query;
	      query = this.getRecentEngagementsQuery(contact_id, type);
	      return query.toJSON();
	    }
	  };
	};

	module.exports = Facebook();


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var Query, _;

	_ = __webpack_require__(2);

	Query = function(Parameters) {
	  var _mapParameters, params, query_object;
	  params = Parameters || [];
	  query_object = {};
	  _mapParameters = function(all_params) {
	    var parameterMap;
	    parameterMap = {};
	    _.each(all_params, function(param) {
	      var name;
	      if (parameterMap[name = param.type()] == null) {
	        parameterMap[name] = [];
	      }
	      return parameterMap[param.type()].push(param);
	    });
	    return parameterMap;
	  };
	  return {
	    toJSON: function() {
	      query_object = {};
	      _.each(params, function(param) {
	        var parameter_object;
	        parameter_object = param.toJSON();
	        return _.each(parameter_object, function(properties, type) {
	          if (query_object[type] == null) {
	            query_object[type] = [];
	          }
	          return _.each(properties, function(prop) {
	            return query_object[type].push(prop);
	          });
	        });
	      });
	      return query_object;
	    },
	    toOrJSON: function() {
	      query_object = {};
	      _.each(params, function(param) {
	        var parameter_object;
	        parameter_object = param.toJSON({
	          exclude_parent: true
	        });
	        return _.each(parameter_object, function(properties, type) {
	          var base;
	          if (query_object[type] == null) {
	            query_object[type] = [];
	          }
	          if ((base = query_object[type])[0] == null) {
	            base[0] = {};
	          }
	          return _.each(properties, function(prop) {
	            return _.extend(query_object[type][0], prop);
	          });
	        });
	      });
	      return query_object;
	    },
	    add: function(Parameter) {
	      return params.push(Parameter);
	    },
	    merge: function(query) {
	      var all_params, parameterMap;
	      all_params = _.flatten([query.parameters(), params]);
	      parameterMap = _mapParameters(all_params);
	      params = [];
	      return _.each(parameterMap, function(parameters, type) {
	        var initial_param;
	        if (parameters.length > 1) {
	          initial_param = _.first(parameters);
	          if (typeof initial_param.isChildDocument === "function" ? initial_param.isChildDocument() : void 0) {
	            _.each(parameters, function(param, index) {
	              if (index !== 0) {
	                return initial_param.merge(param);
	              }
	            });
	          } else {
	            _.each(parameters, function(param, index) {
	              if (index !== 0) {
	                return initial_param.addProperties(param.properties());
	              }
	            });
	          }
	          return params.push(initial_param);
	        } else {
	          return params.push(_.first(parameters));
	        }
	      });
	    },
	    parameters: function() {
	      return params;
	    },
	    parameterKeys: function() {
	      return _.map(params, function(param) {
	        return typeof param.type === "function" ? param.type() : void 0;
	      });
	    },
	    properties: function() {
	      return _.map(params, function(param) {
	        return param.properties();
	      });
	    },
	    propertyKeys: function() {
	      return _.uniq(_.flatten(_.map(params, function(param) {
	        return param.propertyKeys();
	      })));
	    },
	    getAllProperties: function() {
	      return _.flatten(_.map(params, function(param) {
	        return param.propertyKeys();
	      }));
	    },
	    hasParam: function(key) {
	      return _.contains(this.parameterKeys(), key);
	    },
	    hasChildParam: function() {
	      return _.any(params, function(p) {
	        return typeof p.isChildDocument === "function" ? p.isChildDocument() : void 0;
	      });
	    }
	  };
	};

	module.exports = Query;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var Helpers, Parameter, _;

	_ = __webpack_require__(2);

	Helpers = __webpack_require__(7);

	Parameter = function(type, Properties) {
	  var all_properties, param_type, parameter_object, parentPropMap, properties, propertiesWithParents, setProperties;
	  parameter_object = {};
	  param_type = type;
	  parameter_object[param_type] = [];
	  all_properties = Properties;
	  properties = [];
	  propertiesWithParents = [];
	  parentPropMap = {};
	  setProperties = function() {
	    properties = _.filter(all_properties, function(Prop) {
	      if (!(Prop != null ? typeof Prop.parent === "function" ? Prop.parent() : void 0 : void 0)) {
	        return Prop;
	      }
	    });
	    propertiesWithParents = _.filter(all_properties, function(Prop) {
	      if (Prop != null ? typeof Prop.parent === "function" ? Prop.parent() : void 0 : void 0) {
	        return Prop;
	      }
	    });
	    return _.each(propertiesWithParents, function(Prop) {
	      var name;
	      if (parentPropMap[name = Prop.parent()] == null) {
	        parentPropMap[name] = [];
	      }
	      return parentPropMap[Prop.parent()].push(Prop);
	    });
	  };
	  setProperties();
	  return {
	    toJSON: function(options) {
	      if (options == null) {
	        options = {};
	      }
	      if (param_type === "like") {
	        parameter_object[param_type] = properties;
	        return parameter_object;
	      }
	      _.each(properties, function(prop) {
	        return parameter_object[param_type].push(prop.toJSON());
	      });
	      if (options.exclude_parent) {
	        return _.each(propertiesWithParents, function(prop) {
	          return parameter_object[param_type].push(prop.toJSON());
	        });
	      } else {
	        _.each(parentPropMap, function(props, parent) {
	          var prop, property_wrapper;
	          if (props.length > 1) {
	            property_wrapper = {};
	            _.each(props, function(prop) {
	              return Helpers.deepObjectExtend(property_wrapper, prop.toJSONwithParent());
	            });
	            return parameter_object[param_type].push(property_wrapper);
	          } else {
	            prop = _.first(props);
	            return parameter_object[param_type].push(prop.toJSON());
	          }
	        });
	        return parameter_object;
	      }
	    },
	    addProperties: function(Props) {
	      _.each(Props, function(prop) {
	        return all_properties.push(prop);
	      });
	      return setProperties();
	    },
	    properties: function() {
	      return all_properties;
	    },
	    propertyKeys: function() {
	      return _.flatten(_.map(all_properties, function(prop) {
	        return prop.keys();
	      }));
	    },
	    type: function() {
	      return type;
	    }
	  };
	};

	module.exports = Parameter;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var Helpers, _;

	_ = __webpack_require__(2);

	Helpers = {
	  parse: function(group) {
	    return _.map(group, function(obj) {
	      var lookup;
	      lookup = {};
	      _.each(obj.properties, function(prop) {
	        return lookup[prop.name] = prop;
	      });
	      return lookup;
	    });
	  },
	  compactObject: function(object) {
	    var obj;
	    obj = {};
	    _.each(object, function(value, key) {
	      if (!(_.isUndefined(value) || _.isNull(value))) {
	        return obj[key] = value;
	      }
	    });
	    return obj;
	  },
	  toBoolean: function(val) {
	    try {
	      return JSON.parse(val);
	    } catch (error) {
	      if (val === true || val === "true") {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  },
	  cloneData: function(item) {
	    if (!_.isObject(item) || _.isFunction(item)) {
	      return item;
	    } else if (_.isArray(item)) {
	      return _.map(item, this.cloneData);
	    } else if (_.isObject(item)) {
	      return _.mapObject(item, this.cloneData);
	    } else {
	      return item;
	    }
	  },
	  deepObjectExtend: function(target, source) {
	    var prop;
	    for (prop in source) {
	      if (source.hasOwnProperty(prop)) {
	        if (target[prop] && typeof source[prop] === "object") {
	          this.deepObjectExtend(target[prop], source[prop]);
	        } else {
	          target[prop] = source[prop];
	        }
	      }
	    }
	    return target;
	  },
	  toObject: function(key, value, obj) {
	    if (obj == null) {
	      obj = {};
	    }
	    if (key != null) {
	      obj[key] = value;
	    }
	    return obj;
	  }
	};

	module.exports = Helpers;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var Helpers, Operator, Property, _;

	_ = __webpack_require__(2);

	Helpers = __webpack_require__(7);

	Operator = __webpack_require__(9);

	Property = function(prop, value, options) {
	  var isNestedType, properties, property, property_object, type;
	  if (options == null) {
	    options = {};
	  }
	  property_object = {};
	  isNestedType = false;
	  type = options.type;
	  property = prop;
	  properties = _.isArray(prop) ? prop : [prop];
	  return {
	    value: function() {
	      return value;
	    },
	    parent: function() {
	      return options.parent;
	    },
	    isNestedType: function() {
	      this.toJSON();
	      return isNestedType;
	    },
	    keys: function(withoutParent) {
	      if (withoutParent || !options.parent) {
	        return properties;
	      }
	      return _.map(properties, function(prop) {
	        return options.parent + "." + prop;
	      });
	    },
	    toJSON: function(opts) {
	      if (opts == null) {
	        opts = {};
	      }
	      _.each(properties, function(p) {
	        var operator;
	        property = options.parent && !opts.exclude_parent ? options.parent + "." + p : p;
	        operator = Operator(property, value, type);
	        Helpers.deepObjectExtend(property_object, operator.toJSON());
	        return isNestedType = operator.isNestedType();
	      });
	      return property_object;
	    },
	    toJSONwithParent: function() {
	      var object, parent_operator;
	      object = this.toJSON({
	        exclude_parent: true
	      });
	      parent_operator = Operator(options.parent, object, options.parent_type);
	      return parent_operator.toJSON();
	    },
	    orProperties: function(properties) {
	      var more_properties;
	      more_properties = [];
	      _.each(properties, function(prop) {
	        more_properties.push(prop.properties);
	        return Helpers.deepObjectExtend(property_object, prop.toJSON());
	      });
	      properties = _.flatten([properties, more_properties]);
	      return this;
	    }
	  };
	};

	module.exports = Property;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var Helpers, OperatorQuery, _;

	_ = __webpack_require__(2);

	Helpers = __webpack_require__(7);

	OperatorQuery = function(property, val, type) {
	  var isNestedType, operator_object, query_types, value, wrapper;
	  operator_object = {};
	  isNestedType = false;
	  value = val;
	  if (_.isObject(val) && !_.isArray(val)) {
	    value = Helpers.cloneData(val);
	  }
	  if (!type) {
	    if (_.isArray(value)) {
	      type = "contains";
	    } else if (_.isObject(value)) {
	      type = "object";
	    } else {
	      type = "equals";
	    }
	  }
	  wrapper = function(operator) {
	    isNestedType = true;
	    operator_object[property] = {};
	    return operator_object[property][operator] = value;
	  };
	  query_types = {
	    contains: function() {
	      return wrapper("in");
	    },
	    object: function() {
	      return operator_object[property] = value;
	    },
	    equals: function() {
	      return wrapper("match");
	    },
	    exists: function() {
	      return wrapper("exists");
	    },
	    instance: function() {
	      return wrapper("instance");
	    },
	    group: function() {
	      return wrapper("bucket_by");
	    },
	    passThrough: function() {
	      return operator_object = value;
	    },
	    coerce: function() {
	      operator_object[property] = value || {};
	      return operator_object[property].coerce = 0;
	    },
	    wildcard: function() {
	      return operator_object[property] = {
	        wildcard: value + "*"
	      };
	    }
	  };
	  return {
	    toJSON: function() {
	      query_types[type]();
	      return operator_object;
	    },
	    isNestedType: function() {
	      return isNestedType;
	    }
	  };
	};

	module.exports = OperatorQuery;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var ChildDoc, FilterConfig, Filters, Helpers, Parameter, Property, Query, _;

	_ = __webpack_require__(2);

	Helpers = __webpack_require__(7);

	FilterConfig = __webpack_require__(11);

	Query = __webpack_require__(5);

	Parameter = __webpack_require__(6);

	Property = __webpack_require__(8);

	ChildDoc = __webpack_require__(13);

	Filters = function() {
	  var Config, _getByKeyOrId, api;
	  Config = Helpers.cloneData(FilterConfig);
	  Config = _.mapObject(Config, function(val, key) {
	    return _.extend(val, {
	      key: key
	    });
	  });
	  _getByKeyOrId = function(key_or_id) {
	    if (!key_or_id) {
	      return;
	    }
	    if (_.isNaN(parseFloat(key_or_id))) {
	      return Config[key_or_id];
	    } else {
	      return _.findWhere(Config, {
	        filter_id: key_or_id
	      });
	    }
	  };
	  return api = {
	    getQuery: function(filter_object) {
	      var fullQuery;
	      fullQuery = Query();
	      _.each(filter_object, function(val, filter_key) {
	        var conf, query;
	        conf = Config[filter_key];
	        if (typeof conf.validation_fn === "function") {
	          conf.validation_fn(val);
	        }
	        query = conf != null ? typeof conf.query_fn === "function" ? conf.query_fn(val) : void 0 : void 0;
	        if (!_.isEmpty(query)) {
	          return fullQuery.merge(query);
	        }
	      });
	      return fullQuery;
	    },
	    getQueryJSON: function(filter_object) {
	      var fullQuery;
	      fullQuery = this.getQuery(filter_object);
	      return fullQuery.toJSON();
	    },
	    getConfigFor: function(filter_key) {
	      return _getByKeyOrId(filter_key);
	    },
	    getFacetsFor: function(filter_key) {
	      var fields, filter_facets, ref;
	      filter_facets = (ref = _getByKeyOrId(filter_key)) != null ? ref.facets : void 0;
	      if (_.isArray(filter_facets)) {
	        fields = _.map(filter_facets, function(facet) {
	          return {
	            field: facet
	          };
	        });
	      } else if (_.isArray(filter_facets != null ? filter_facets.fields : void 0)) {
	        fields = _.map(filter_facets.fields, function(facet) {
	          return {
	            field: facet
	          };
	        });
	      } else if (_.isObject(filter_facets != null ? filter_facets.fields : void 0)) {
	        fields = _.map(filter_facets.fields, function(facet, label) {
	          return {
	            field: facet,
	            label: label
	          };
	        });
	      }
	      return {
	        type: (filter_facets != null ? filter_facets.type : void 0) || "contact",
	        fields: fields
	      };
	    },
	    getMergedConfig: function(list_filter_items_json) {
	      var merged_config;
	      merged_config = Helpers.cloneData(Config);
	      _.each(list_filter_items_json, function(filter) {
	        var filter_config;
	        filter_config = _.findWhere(merged_config, {
	          filter_id: filter.filter_id
	        });
	        return _.extend(filter_config, {
	          label: filter.label
	        });
	      });
	      return merged_config;
	    },
	    getMergedQuery: function(query1, query2) {
	      if (!_.isEmpty(query1) && !_.isEmpty(query2)) {
	        query1.merge(query2);
	        return query1;
	      }
	    },
	    getCustomQuery: function(key, value, type) {
	      return Query([
	        Parameter("must", [
	          Property(key, value, {
	            type: type
	          })
	        ])
	      ]);
	    }
	  };
	};

	module.exports = Filters();


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var ChildDoc, FilterConfig, FilterConfigModule, Helpers, Parameter, Property, Query, _, moment,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	_ = __webpack_require__(2);

	moment = __webpack_require__(12);

	Helpers = __webpack_require__(7);

	Query = __webpack_require__(5);

	Parameter = __webpack_require__(6);

	Property = __webpack_require__(8);

	ChildDoc = __webpack_require__(13);

	FilterConfig = function() {
	  var _formatOrProperties, _getQueryObjectForDate;
	  _getQueryObjectForDate = function(object) {
	    var val;
	    if (object.value === "range" && object.range) {
	      val = _.clone(object.range);
	      if (val.gte) {
	        val.gte = moment(val.gte).format("YYYY-MM-DD");
	      }
	      if (val.lte) {
	        val.lte = moment(val.lte).format("YYYY-MM-DD");
	      }
	    } else {
	      val = {
	        gte: object != null ? object.value : void 0
	      };
	    }
	    return val;
	  };
	  _formatOrProperties = function(prop_values) {
	    var properties, query_prop;
	    properties = _.compact(_.map(prop_values, function(val, key) {
	      if (!_.isEmpty(val)) {
	        return Property(key, val, {
	          type: "contains"
	        });
	      }
	    }));
	    query_prop = properties.shift() || Property(_.keys(properties), null, {
	      type: "contains"
	    });
	    if (properties.length && query_prop) {
	      query_prop.orProperties(properties);
	    }
	    return query_prop;
	  };
	  return {
	    map: {
	      filter_id: "0.0",
	      value_type: "object",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("location", value, {
	              type: "object",
	              parent: "addresses",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    full_name: {
	      filter_id: "0.01",
	      value_type: "string",
	      query_fn: function(value) {
	        var names, properties;
	        names = value ? value != null ? typeof value.split === "function" ? value.split(" ") : void 0 : void 0 : [value];
	        properties = _.map(names, function(name) {
	          return Property(["name_first", "name_last", "name_nick", "name_maiden", "name_suffix", "name_prefix"], name, {
	            type: "wildcard"
	          });
	        });
	        return Query([Parameter("must", properties)]);
	      }
	    },
	    capacity_score: {
	      filter_id: "1.1",
	      facets: ["giving.capacity_score.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("giving.capacity_score.untouched", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    rated: {
	      filter_id: "1.2",
	      value_type: "boolean",
	      query_fn: function(value) {
	        var query_value;
	        query_value = value && value === "true" || value === true ? true : false;
	        return Query([
	          Parameter("must", [
	            Property("giving.capacity_score", query_value, {
	              type: "exists"
	            })
	          ])
	        ]);
	      }
	    },
	    wealthy_neighborhood: {
	      filter_id: "1.3",
	      value_type: "boolean",
	      query_fn: function(value) {
	        var param_type;
	        param_type = value && value === "true" || value === true ? "must" : "must_not";
	        return Query([
	          Parameter(param_type, [
	            Property("house_value_median", {
	              gte: 1000000
	            }, {
	              type: "coerce",
	              parent: "addresses",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    median_home_value: {
	      filter_id: "1.4",
	      value_type: "object",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("house_value_median", value, {
	              type: "coerce",
	              parent: "addresses",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    median_income: {
	      filter_id: "1.5",
	      value_type: "object",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("income_median", value, {
	              type: "coerce",
	              parent: "addresses",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    engagement_score: {
	      filter_id: "2.1",
	      facets: ["giving.engagement_score.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("giving.engagement_score.untouched", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    facebook_engagement: {
	      filter_id: "2.2",
	      value_type: "boolean",
	      query_fn: function(value) {
	        var property;
	        property = value && value === "true" || value === true ? "must" : "must_not";
	        return Query([
	          Parameter(property, [
	            Property(["facebook.like_count", "facebook.comment_count"], {
	              gt: 0
	            }, {
	              type: "coerce"
	            })
	          ])
	        ]);
	      }
	    },
	    last_fb_engagement_date: {
	      filter_id: "2.3",
	      value_type: "object",
	      query_fn: function(value) {
	        var ref, val;
	        val = _getQueryObjectForDate(value);
	        return Query([
	          Parameter(((ref = value.parameter) != null ? ref.value : void 0) || "must", [
	            Property("facebook.last_engagement_date", val, {
	              type: "object"
	            })
	          ])
	        ]);
	      }
	    },
	    facebook_likes: {
	      filter_id: "2.4",
	      value_type: "range",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("facebook.like_count", value, {
	              type: "coerce"
	            })
	          ])
	        ]);
	      }
	    },
	    facebook_comments: {
	      filter_id: "2.5",
	      value_type: "range",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("facebook.comment_count", value, {
	              type: "coerce"
	            })
	          ])
	        ]);
	      }
	    },
	    lifetime_recognition: {
	      filter_id: "3.01",
	      value_type: "range",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("giving.lifetime_recognition_amount", value, {
	              type: "coerce"
	            })
	          ])
	        ]);
	      }
	    },
	    giving_history: {
	      filter_id: "3.1",
	      value_type: "boolean",
	      query_fn: function(value) {
	        var property;
	        property = value && value === "true" || value === true ? "must" : "must_not";
	        return Query([
	          Parameter(property, [
	            Property("giving.lifetime_amount", {
	              gt: 0
	            }, {
	              type: "coerce"
	            })
	          ])
	        ]);
	      }
	    },
	    lifetime_giving: {
	      filter_id: "3.3",
	      value_type: "range",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("giving.lifetime_amount", value, {
	              type: "coerce"
	            })
	          ])
	        ]);
	      }
	    },
	    largest_gift: {
	      filter_id: "3.6",
	      value_type: "range",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("giving.largest_gift_amount", value, {
	              type: "coerce"
	            })
	          ])
	        ]);
	      }
	    },
	    last_gift: {
	      filter_id: "3.4",
	      value_type: "range",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("giving.last_gift_amount", value, {
	              type: "coerce"
	            })
	          ])
	        ]);
	      }
	    },
	    last_gift_date: {
	      filter_id: "3.5",
	      value_type: "object",
	      query_fn: function(value) {
	        var ref, val;
	        val = _getQueryObjectForDate(value);
	        if (!val.lte) {
	          val.lte = "now";
	        }
	        return Query([
	          Parameter((ref = value.parameter) != null ? ref.value : void 0, [
	            Property("giving.last_gift_date", val, {
	              type: "object"
	            })
	          ])
	        ]);
	      }
	    },
	    giving_pattern: {
	      filter_id: "3.7",
	      value_type: "object",
	      query_fn: function(value) {
	        var properties, propertiesList, valuesArray;
	        valuesArray = _.pluck(value, "value");
	        properties = _.contains(valuesArray, null) || _.contains(valuesArray, "") ? (propertiesList = [
	          Property("giving.giving_pattern", false, {
	            type: "exists"
	          })
	        ], _.compact(valuesArray).length > 0 ? propertiesList.push(Property("giving.giving_pattern", _.compact(valuesArray), {
	          type: "contains"
	        })) : void 0, propertiesList) : [
	          Property("giving.giving_pattern", valuesArray, {
	            type: "contains"
	          })
	        ];
	        return Query([Parameter("should", properties)]);
	      }
	    },
	    et_index: {
	      filter_id: "5.1b",
	      facets: ["giving.et_donor_index"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("giving.et_donor_index", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    industry: {
	      filter_id: "4.1",
	      facets: {
	        fields: {
	          "Your Industries": "employments.industry.untouched"
	        }
	      },
	      value_type: "array",
	      query_fn: function(values) {
	        var properties;
	        properties = _formatOrProperties({
	          "employments.industry.untouched": values.customer
	        });
	        return Query([Parameter("must", [properties])]);
	      }
	    },
	    industry_customer_only: {
	      filter_id: "4.1.2",
	      facets: ["employments.industry.untouched"],
	      value_type: "array",
	      query_fn: function(values) {
	        return Query([
	          Parameter("must", [
	            Property("employments.industry.untouched", values, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    company: {
	      filter_id: "4.2",
	      facets: {
	        fields: ["employments.company.untouched"]
	      },
	      value_type: "array",
	      query_fn: function(values) {
	        var properties;
	        properties = _formatOrProperties({
	          "employments.company.untouched": values.customer
	        });
	        return Query([Parameter("must", [properties])]);
	      }
	    },
	    company_customer_only: {
	      filter_id: "4.2.2",
	      facets: ["employments.company.untouched"],
	      value_type: "array",
	      query_fn: function(values) {
	        return Query([
	          Parameter("must", [
	            Property("employments.company.untouched", values, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    company_enrichment: {
	      filter_id: "4.2.3",
	      facets: ["enrichment.employments.company_name.untouched"],
	      value_type: "array",
	      query_fn: function(values) {
	        return Query([
	          Parameter("must", [
	            Property("enrichment.employments.company_name.untouched", values, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    title: {
	      filter_id: "4.4",
	      facets: ["employments.title.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("employments.title.untouched", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    title_enrichment: {
	      filter_id: "4.4.1",
	      facets: ["enrichment.employments.title.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("enrichment.employments.title.untouched", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    "function": {
	      filter_id: "4.5",
	      facets: ["employments.function.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("employments.function.untouched", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    score_et: {
	      filter_id: "5.1a",
	      value_type: "range",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("score.score", value, {
	              type: "coerce"
	            })
	          ])
	        ]);
	      }
	    },
	    donor_score: {
	      filter_id: "5.2",
	      facets: ["giving.donor_score.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("giving.donor_score.untouched", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    assignee: {
	      filter_id: "5.3",
	      facets: ["assignees.name.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("name.untouched", value, {
	              type: "contains",
	              parent: "assignees",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    rm_assignee: {
	      filter_id: "12.6",
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          ChildDoc("assignment", Query([
	            Parameter("must", [
	              Property("pool_type", "TEAM", {
	                type: "equals"
	              }), Property("solicitor_contact_id", value, {
	                type: "contains"
	              }), Property("parent_role", "prospect", {
	                type: "equals"
	              })
	            ])
	          ]))
	        ]);
	      }
	    },
	    assigned: {
	      filter_id: "5.4",
	      value_type: "boolean",
	      query_fn: function(value) {
	        var param_type;
	        param_type = value && value === "true" || value === true ? "must" : "must_not";
	        return Query([
	          Parameter(param_type, [
	            Property("name", true, {
	              type: "exists",
	              parent: "assignees",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    solicitation_code: {
	      filter_id: "5.5",
	      facets: ["solicitation_codes.code"],
	      value_type: "array",
	      query_fn: function(value) {
	        var param, ref;
	        param = value != null ? (ref = value.parameter) != null ? ref.value : void 0 : void 0;
	        return Query([
	          Parameter(param || "must", [
	            Property("solicitation_codes.code", value != null ? value.value : void 0, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    prospect_status: {
	      filter_id: "5.6",
	      facets: ["assignees.status"],
	      value_type: "array",
	      query_fn: function(value) {
	        var param, ref;
	        param = value != null ? (ref = value.parameter) != null ? ref.value : void 0 : void 0;
	        return Query([
	          Parameter(param || "must", [
	            Property("status", value != null ? value.value : void 0, {
	              type: "contains",
	              parent: "assignees",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    deceased: {
	      filter_id: "1.6",
	      value_type: "boolean",
	      query_fn: function(value) {
	        var query_value;
	        query_value = value && value === "true" || value === true ? true : false;
	        return Query([
	          Parameter("must", [
	            Property("deceased", query_value, {
	              type: "equals"
	            })
	          ])
	        ]);
	      }
	    },
	    year: {
	      filter_id: "6.1",
	      value_type: "range",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("year", value, {
	              type: "object"
	            })
	          ])
	        ]);
	      }
	    },
	    reunion_year: {
	      filter_id: "6.2",
	      value_type: "array",
	      query_fn: function(values) {
	        var current_year, first_year, groups, i, results, reunions;
	        current_year = moment(new Date()).year();
	        first_year = current_year - 150;
	        groups = _.flatten(_.map(values, function(value) {
	          return (value != null ? typeof value.split === "function" ? value.split("and") : void 0 : void 0) || [];
	        }));
	        reunions = _.compact(_.map((function() {
	          results = [];
	          for (var i = first_year; first_year <= current_year ? i <= current_year : i >= current_year; first_year <= current_year ? i++ : i--){ results.push(i); }
	          return results;
	        }).apply(this), function(year) {
	          var ref;
	          if ((ref = _.last(year.toString()), indexOf.call(groups, ref) >= 0)) {
	            return parseInt(year);
	          }
	        }));
	        return Query([
	          Parameter("must", [
	            Property("year", reunions, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    education: {
	      filter_id: "6.3",
	      facets: ["educations.school_name.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("school_name.untouched", value, {
	              type: "contains",
	              parent: "educations",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    degree: {
	      filter_id: "6.4",
	      facets: ["educations.degree_key.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("degree_key.untouched", value, {
	              type: "contains",
	              parent: "educations",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    major: {
	      filter_id: "6.5",
	      facets: ["educations.majors.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("majors.untouched", value, {
	              type: "contains",
	              parent: "educations",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    education_year: {
	      filter_id: "6.51",
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("year", value, {
	              type: "object",
	              parent: "educations",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    athletics: {
	      filter_id: "6.6",
	      facets: ["sports.name.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("sports.name.untouched", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    activities: {
	      filter_id: "6.7",
	      facets: ["extracurricular_activities.name.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("extracurricular_activities.name.untouched", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    location_enrichment: {
	      filter_id: "7.1.1",
	      facets: ["enrichment.enrichment_attributes.location_general.untouched"],
	      value_type: "array",
	      query_fn: function(values) {
	        return Query([
	          Parameter("must", [
	            Property("enrichment.enrichment_attributes.location_general.untouched", values, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    address_city: {
	      filter_id: "7.2",
	      facets: ["addresses.city.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("city.untouched", value, {
	              type: "contains",
	              parent: "addresses",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    address_state: {
	      filter_id: "7.3",
	      facets: ["addresses.state.untouched"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("state.untouched", value, {
	              type: "contains",
	              parent: "addresses",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    address_type: {
	      filter_id: "7.4",
	      facets: ["addresses.type"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("type", value, {
	              type: "contains",
	              parent: "addresses",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    zipcode: {
	      filter_id: "7.5",
	      facets: ["addresses.zip_code"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("zip_code", value, {
	              type: "contains",
	              parent: "addresses",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    gender: {
	      filter_id: "8.0",
	      facets: ["gender"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("gender", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    ethnicity: {
	      filter_id: "8.1",
	      facets: ["ethnicity"],
	      value_type: "array",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("ethnicity", value, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    constituency: {
	      filter_id: "8.2",
	      facets: ["constituencies.status"],
	      value_type: "array",
	      query_fn: function(value) {
	        var param, ref;
	        param = value != null ? (ref = value.parameter) != null ? ref.value : void 0 : void 0;
	        return Query([
	          Parameter(param || "must", [
	            Property("constituencies.status", value != null ? value.value : void 0, {
	              type: "contains"
	            })
	          ])
	        ]);
	      }
	    },
	    age_enrichment: {
	      filter_id: "8.3",
	      value_type: "range",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("age", value, {
	              type: "coerce",
	              parent: "enrichment.enrichment_attributes",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    interests_enrichment: {
	      filter_id: "8.4",
	      facets: ["enrichment.contact_interests.interest_name.untouched"],
	      value_type: "array",
	      query_fn: function(values) {
	        return Query([
	          Parameter("must", [
	            Property("interest_name.untouched", values, {
	              type: "contains",
	              parent: "enrichment.contact_interests",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    mentor: {
	      filter_id: "9",
	      value_type: "boolean",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("mentor", value, {
	              type: "equals"
	            })
	          ])
	        ]);
	      }
	    },
	    graduway_registered_user: {
	      filter_id: "10.1",
	      value_type: "boolean",
	      query_fn: function(value) {
	        var query_value;
	        query_value = value && value === "true" || value === true ? true : false;
	        return Query([
	          Parameter("must", [
	            Property("graduway.is_graduway_user", query_value, {
	              type: "exists"
	            })
	          ])
	        ]);
	      }
	    },
	    graduway_last_engagement_date: {
	      filter_id: "10.2",
	      value_type: "object",
	      query_fn: function(value) {
	        return Query([
	          Parameter("must", [
	            Property("graduway.last_graduway_session_at", value, {
	              type: "object"
	            })
	          ])
	        ]);
	      }
	    }
	  };
	};

	FilterConfigModule = function() {
	  var _validate;
	  _validate = function(key, type, validator) {
	    return function(val) {
	      if (!validator(val)) {
	        return console.warn("Value for " + key + " should be " + type);
	      }
	    };
	  };
	  return _.mapObject(Helpers.cloneData(FilterConfig()), function(config, key) {
	    var validation_fn;
	    validation_fn = (function() {
	      switch (config.value_type) {
	        case "array":
	          return _validate(key, "array", _.isArray);
	        case "string":
	          return _validate(key, "string", _.isString);
	        case "boolean":
	          return _validate(key, "boolean", _.isBoolean);
	        case "range":
	          return _validate(key, "range", function(val) {
	            return val.gt || val.gte || val.lte || val.lt;
	          });
	        case "object":
	          return _validate(key, "object", function(val) {
	            return _.isObject(val) && !_.isArray(val);
	          });
	        default:
	          console.warn("Unknown validation value_type " + config.value_type);
	          return void 0;
	      }
	    })();
	    return _.extend(config, {
	      validation_fn: validation_fn
	    });
	  });
	};

	module.exports = FilterConfigModule();


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var ChildDoc, _;

	_ = __webpack_require__(2);

	ChildDoc = function(type, ChildQuery) {
	  var _query, query_object;
	  query_object = {
	    type: type,
	    query: {}
	  };
	  _query = ChildQuery;
	  return {
	    toJSON: function() {
	      var query;
	      query_object.query = _query.toJSON();
	      return query = {
	        has_child: [query_object]
	      };
	    },
	    query: function() {
	      return _query;
	    },
	    propertyKeys: function() {
	      return _query.propertyKeys();
	    },
	    properties: function() {
	      return _query.properties();
	    },
	    merge: function(InnerQuery) {
	      return _query.merge(InnerQuery.query());
	    },
	    type: function() {
	      return type;
	    },
	    isChildDocument: function() {
	      return true;
	    }
	  };
	};

	module.exports = ChildDoc;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var CommentMixin, Contacts, Interactions, Parameter, Profile, Property, Query, SEARCH_CONFIG, VOLUNTEER_CONTACT_LABEL, VOLUNTEER_POOL_LABEL, _, _classifyName, _getContactName, _getPropertiesForCategoryQuery, _getUserName, _makeContactAlias, _makeUserAlias, _parseCallback, moment,
	  slice = [].slice;

	_ = __webpack_require__(2);

	moment = __webpack_require__(12);

	Contacts = __webpack_require__(3);

	CommentMixin = __webpack_require__(15);

	Query = __webpack_require__(5);

	Parameter = __webpack_require__(6);

	Property = __webpack_require__(8);

	Profile = __webpack_require__(16);

	VOLUNTEER_CONTACT_LABEL = "Volunteer Contact ID";

	VOLUNTEER_POOL_LABEL = "Volunteer Pool ID";

	_classifyName = function(name) {
	  return CommentMixin.classify(name.toLowerCase());
	};

	_getUserName = function(user) {
	  return user != null ? user.name : void 0;
	};

	_getContactName = function(parsed_contact) {
	  return Contacts.getDetailedName(parsed_contact);
	};

	_makeContactAlias = function(contact) {
	  return _classifyName(_getContactName(contact));
	};

	_makeUserAlias = function(user) {
	  return _classifyName(_getUserName(user));
	};

	SEARCH_CONFIG = {
	  base: function(id, sort_order) {
	    if (sort_order == null) {
	      sort_order = "desc";
	    }
	    return Query([
	      Parameter("must", [
	        Property("target_id", id, {
	          type: "equals"
	        })
	      ]), Parameter("sort", [
	        Property("date_occurred", {
	          order: sort_order
	        }, {
	          type: "object"
	        })
	      ])
	    ]);
	  },
	  category: function(categories) {
	    return Query([Parameter("must", _getPropertiesForCategoryQuery(categories))]);
	  },
	  keyword: function(val) {
	    var word_array;
	    word_array = _.filter(val != null ? val.split(" ") : void 0, function(word) {
	      return !!word;
	    });
	    return Query([
	      Parameter("must", _.map(word_array, function(val) {
	        return Property(["text", "summary"], val, {
	          type: "wildcard"
	        });
	      }))
	    ]);
	  },
	  date: function(val) {
	    var date_object;
	    date_object = {
	      gte: val.date_from,
	      lte: val.date_to
	    };
	    return Query([
	      Parameter("must", [
	        Property("date_occurred", date_object, {
	          type: "object"
	        })
	      ])
	    ]);
	  },
	  author: function(names) {
	    return Query([
	      Parameter("must", [
	        Property("author.name.untouched", names, {
	          type: "contains"
	        })
	      ])
	    ]);
	  }
	};

	_getPropertiesForCategoryQuery = function(categories) {
	  return [
	    Property("interaction_type.untouched", categories, {
	      type: "contains"
	    })
	  ];
	};

	_parseCallback = function(type, id, alias, interaction) {
	  var data, datum, name, removed_type;
	  id = parseInt(_.escape(id), 10);
	  datum = _.find(interaction.mentions, function(mention) {
	    return id === parseInt(mention[type + "_id"], 10);
	  });
	  data = datum != null ? datum.data : void 0;
	  if (data) {
	    switch (type) {
	      case "contact":
	        name = Contacts.getDetailedName(data);
	        return {
	          type: "contact",
	          name: name,
	          id: id
	        };
	      case "user":
	        if (data.name === "Removed User") {
	          return {
	            type: "removed-user",
	            name: data.name,
	            id: id
	          };
	        } else {
	          return {
	            type: "mention",
	            name: data.name,
	            id: id
	          };
	        }
	    }
	  } else {
	    if (_.isNaN(parseInt(alias, 10))) {
	      return {
	        type: "mention",
	        name: CommentMixin.formatAlias(alias) || "",
	        id: id
	      };
	    } else {
	      removed_type = CommentMixin.titleize(alias);
	      return {
	        type: "removed-user",
	        name: "Removed " + removed_type,
	        id: id
	      };
	    }
	  }
	};

	Interactions = function() {
	  var api;
	  return api = {
	    parseTypes: function(dbTypes, includeDXO) {
	      var types;
	      if (dbTypes == null) {
	        dbTypes = [];
	      }
	      if (includeDXO == null) {
	        includeDXO = false;
	      }
	      types = slice.call(dbTypes);
	      if (!types.includes("EverTrue Comment")) {
	        types.push("EverTrue Comment");
	      }
	      if (!types.includes("DXO Ask") && includeDXO) {
	        types.push("DXO Ask");
	      }
	      return types;
	    },
	    getInteractionSummary: function(json, type) {
	      var contactInfo, label, ref, ref1, ref2, ret, value;
	      contactInfo = Profile.getPrimaryContactInfo(json);
	      value = type === "Volunteer Phonecall" ? (ref = contactInfo.phone) != null ? ref.phone : void 0 : type === "Volunteer Email" ? (ref1 = contactInfo.email) != null ? ref1.email : void 0 : type === "Volunteer Text Message" ? (ref2 = contactInfo.phone) != null ? ref2.phone : void 0 : type === "Volunteer Social" ? "LinkedIn" : "";
	      label = type === "Volunteer Phonecall" ? "Called at" : type === "Volunteer Email" ? "Sent Email to" : type === "Volunteer Text Message" ? "Sent Text Message to" : type === "Volunteer Social" ? "Sent Social Media Message on" : "";
	      return ret = {
	        "label": label,
	        "value": value
	      };
	    },
	    getInteractionForDisplay: function(type) {
	      var ret, value;
	      value = type === "Volunteer Phonecall" ? "Phone Call" : type === "Volunteer Email" ? "Email" : type === "Volunteer Text Message" ? "Text Message" : type === "Volunteer Social" ? "Social Media Interaction" : type === "Volunteer Note" ? "Note" : type === "Volunteer Virtual Visit" ? "Virtual Visit" : void 0;
	      return ret = {
	        "actual": type,
	        "display": value
	      };
	    },
	    getSearchQuery: function(id, sort, filter_object) {
	      var query;
	      query = SEARCH_CONFIG.base(id, sort);
	      _.each(filter_object, function(filter_value, key) {
	        var query_value;
	        if (query_value = typeof SEARCH_CONFIG[key] === "function" ? SEARCH_CONFIG[key](filter_value) : void 0) {
	          return query.merge(query_value);
	        }
	      });
	      return query;
	    },
	    getSearchQueryJSON: function(id, sort, filter_object) {
	      var query;
	      query = this.getSearchQuery(id, sort, filter_object);
	      return query.toJSON();
	    },
	    getAuthorName: function(interaction, org_name) {
	      var author_name, is_gt_comment, ref, ref1, ref2;
	      author_name = (interaction != null ? (ref = interaction.author) != null ? ref.name : void 0 : void 0) || (interaction != null ? (ref1 = interaction.creator) != null ? ref1.name : void 0 : void 0);
	      is_gt_comment = (interaction != null ? interaction.interaction_type : void 0) === "EverTrue Comment";
	      if (author_name) {
	        return author_name;
	      } else if (is_gt_comment) {
	        return "Removed User";
	      } else if (!author_name && !_.isEmpty(interaction != null ? interaction.solicitor : void 0)) {
	        return (ref2 = _.pluck(interaction != null ? interaction.solicitor : void 0, "name")) != null ? ref2.join(" | ") : void 0;
	      } else {
	        return org_name + " Author";
	      }
	    },
	    getTextSnippet: function(interaction) {
	      var text;
	      if (interaction.interaction_type === "EverTrue Comment") {
	        return CommentMixin.getSnippet(interaction.text, 200);
	      } else {
	        text = (interaction != null ? interaction.text : void 0) || "";
	        return text.substr(0, 200) + (text.length > 200 ? "..." : "");
	      }
	    },
	    getParsedTextArray: function(text, interaction) {
	      return CommentMixin.parse(text, function(type, id, alias) {
	        return _parseCallback(type, id, alias, interaction);
	      });
	    },
	    getInteractionLabels: function(interaction) {
	      var has_solicitor_label, labels;
	      labels = _.filter(interaction.label, function(label) {
	        var ref;
	        return !_.isEmpty((ref = label.value) != null ? ref.trim() : void 0) && !(label.name === VOLUNTEER_CONTACT_LABEL) && !(label.name === VOLUNTEER_POOL_LABEL);
	      });
	      has_solicitor_label = _.find(labels, function(label) {
	        var ref, ref1;
	        return (ref = label.name) != null ? (ref1 = ref.toLowerCase()) != null ? ref1.match(/^(solicitor|solictors)/) : void 0 : void 0;
	      });
	      if (!has_solicitor_label && !_.isEmpty(interaction.solicitor)) {
	        _.each(interaction.solicitor, function(solicitor) {
	          return labels.push({
	            name: "Solicitors",
	            value: solicitor.name
	          });
	        });
	      }
	      return labels;
	    },
	    getFormattedCustomFieldValue: function(custom_field) {
	      var dataType, num, value;
	      if (custom_field == null) {
	        custom_field = {};
	      }
	      dataType = custom_field.dataType, value = custom_field.value;
	      switch (dataType) {
	        case "BOOLEAN":
	          if (value === true) {
	            return "Yes";
	          } else {
	            return "No";
	          }
	          break;
	        case "DATE":
	          if ((value != null ? value.toString().length : void 0) < 13) {
	            value = value * 1000;
	          }
	          return moment(value).format("L");
	        case "DOUBLE":
	          num = !_.isNumber(value) ? parseFloat(num) : value;
	          return "$" + (num.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
	        default:
	          return value;
	      }
	    },
	    getFormattedInteraction: function(interaction, current_user, reference_data) {
	      var contacts, custom_fields, mentions, pools, proposals, ref, ref1, trips, updated_at, updated_by, user, users, volunteer_contact, volunteer_id, volunteer_pool, volunteer_pool_id;
	      if (interaction == null) {
	        interaction = {};
	      }
	      if (current_user == null) {
	        current_user = {};
	      }
	      if (reference_data == null) {
	        reference_data = {};
	      }
	      users = reference_data.users || {};
	      trips = reference_data.trips || {};
	      contacts = reference_data.contacts || {};
	      pools = reference_data.pools || {};
	      proposals = reference_data.proposals || {};
	      user = users != null ? users[interaction.creator_user_id] : void 0;
	      if (!user && interaction.creator_user_id === (current_user != null ? current_user.id : void 0)) {
	        user = current_user;
	      }
	      mentions = _.flatten([interaction.contact_mention, interaction.user_mention]);
	      custom_fields = interaction.custom_field || [];
	      volunteer_id = (ref = _.findWhere(interaction.label, {
	        name: VOLUNTEER_CONTACT_LABEL
	      })) != null ? ref.value : void 0;
	      volunteer_contact = contacts[volunteer_id] || {};
	      if (!_.isEmpty(volunteer_contact)) {
	        volunteer_contact.name = Contacts.getFullName(volunteer_contact);
	      }
	      volunteer_pool_id = (ref1 = _.findWhere(interaction.label, {
	        name: VOLUNTEER_POOL_LABEL
	      })) != null ? ref1.value : void 0;
	      volunteer_pool = pools[volunteer_pool_id] || {};
	      updated_at = moment(interaction.updated_at).format("MM/D/YYYY");
	      updated_by = interaction.update_source === "EVERTRUE" ? " EverTrue" : " import";
	      return _.extend({}, interaction, {
	        creator: !(user != null ? user.removed : void 0) ? user : void 0,
	        contact_id: interaction.target_id,
	        contact: contacts[interaction.target_id] || {},
	        mentions: _.map(mentions, function(mention) {
	          if (mention.user_id) {
	            return _.extend({}, mention, {
	              data: users[mention.user_id]
	            });
	          } else if (mention.contact_id) {
	            return _.extend({}, mention, {
	              data: contacts[mention.contact_id]
	            });
	          }
	        }),
	        custom_field: _.map(custom_fields, (function(_this) {
	          return function(field) {
	            return _.extend({}, field, {
	              formattedValue: _this.getFormattedCustomFieldValue(field)
	            });
	          };
	        })(this)),
	        label: this.getInteractionLabels(interaction),
	        trip: trips[interaction.trip_id] || {},
	        proposal: proposals[interaction.proposal_id] || {},
	        volunteer: volunteer_contact,
	        volunteer_pool: volunteer_pool,
	        last_update: updated_at + " via " + updated_by
	      });
	    },
	    createUserMentionObject: function(user) {
	      var alias;
	      alias = _makeUserAlias(user);
	      return {
	        user_id: user != null ? user.id : void 0,
	        alias: alias,
	        data: user
	      };
	    },
	    createContactMentionObject: function(contact) {
	      var alias;
	      alias = _makeContactAlias(contact);
	      return {
	        contact_id: contact != null ? contact.id : void 0,
	        alias: alias,
	        data: contact
	      };
	    },
	    createUserMentionString: function(user) {
	      var alias;
	      alias = _makeUserAlias(user);
	      return "<@user:" + (user != null ? user.id : void 0) + ":" + alias + ">";
	    },
	    createContactMentionString: function(contact) {
	      var alias;
	      alias = _makeContactAlias(contact);
	      return "<@contact:" + (contact != null ? contact.id : void 0) + ":" + alias + ">";
	    },
	    getNameFromMentionObject: function(mention) {
	      var name;
	      if (!mention) {
	        return;
	      }
	      if (mention["user_id"] && !_.isEmpty(mention.data)) {
	        name = _getUserName(mention.data);
	      } else if (mention["contact_id"] && !_.isEmpty(mention.data)) {
	        name = _getContactName(mention.data);
	      }
	      return name;
	    },
	    classifyName: function(name) {
	      return _classifyName(name);
	    },
	    getUserName: function(user) {
	      return _getUserName(user);
	    },
	    getContactName: function(parsed_contact) {
	      return _getContactName(parsed_contact);
	    },
	    makeContactAlias: function(contact) {
	      return _makeContactAlias(contact);
	    },
	    makeUserAlias: function(user) {
	      return _makeUserAlias(user);
	    }
	  };
	};

	module.exports = Interactions();


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var CommentMixin, _, _underscored;

	_ = __webpack_require__(2);

	_underscored = function(str) {
	  return str.replace(/([a-z\d])([A-Z]+)/g, "$1_$2").replace(/[-\s]+/g, "_").trim();
	};

	CommentMixin = {
	  dslRegexAll: /\<\@([^<>]+)\>/g,
	  dslRegexCapture: /(\<\@[^<>]+\>)/,
	  dslRegexCaptureInner: /\<[@$](.*)\>/,
	  spanRegexCapture: /\<span.*\>(.*)\<\/span\>/,
	  scriptRegexCapture: /(\<script\>.*\<\/script\>?|\<script.*\/\>)/,
	  parse: function(comment, callback) {
	    var text, textArray;
	    text = this.escapeComment(comment);
	    textArray = text.split(this.dslRegexCapture);
	    return _.compact(_.map(textArray, (function(_this) {
	      return function(word) {
	        var alias, id, inner_mention, ref, type;
	        if (word.search(_this.dslRegexAll) >= 0) {
	          inner_mention = word.replace(_this.dslRegexAll, function(full_match, mention) {
	            return mention;
	          });
	          ref = _this.parseDSL(inner_mention), type = ref[0], id = ref[1], alias = ref[2];
	          return callback(type, id, alias);
	        } else {
	          return word;
	        }
	      };
	    })(this)));
	  },
	  parseDSL: function(string) {
	    var alias, id, match, ref, ref1, ref2, type;
	    match = string.match(this.dslRegexCaptureInner);
	    if (!!match) {
	      ref1 = (ref = match[1]) != null ? ref.split(":") : void 0, type = ref1[0], id = ref1[1], alias = ref1[2];
	    } else {
	      ref2 = string.split(":"), type = ref2[0], id = ref2[1], alias = ref2[2];
	    }
	    return [type, id, alias];
	  },
	  escapeComment: function(string) {
	    var splitText;
	    if (!string) {
	      return "";
	    } else {
	      splitText = string.split(this.dslRegexCapture);
	      _.each(splitText, (function(_this) {
	        return function(text_part, index) {
	          var escaped, span_match;
	          if (!text_part.match(_this.dslRegexCapture)) {
	            escaped = text_part != null ? text_part.replace(_this.scriptRegexCapture, "") : void 0;
	            if (escaped.match(_this.dslRegexCaptureInner) && escaped.match("<span")) {
	              span_match = escaped.match(_this.spanRegexCapture);
	              return splitText[index] = escaped.replace(span_match[0], span_match[1]);
	            } else {
	              return splitText[index] = escaped;
	            }
	          }
	        };
	      })(this));
	      return splitText.join("");
	    }
	  },
	  getSnippet: function(string, max_char_length) {
	    var char_length, indexes, match, ref;
	    if (string == null) {
	      string = "";
	    }
	    indexes = [];
	    while ((match = this.dslRegexAll.exec(string)) !== null) {
	      indexes.push([match.index, match.index + ((ref = match[0]) != null ? ref.length : void 0)]);
	    }
	    char_length = max_char_length;
	    _.each(indexes, function(tuple) {
	      var end, start;
	      start = tuple[0], end = tuple[1];
	      if (start < max_char_length && end > max_char_length) {
	        return char_length = start;
	      }
	    });
	    return string.substr(0, char_length) + (string.length > char_length ? "..." : "");
	  },
	  capitalize: function(str, lowercaseRest) {
	    var remainingChars;
	    str = str.toString();
	    remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();
	    return str.charAt(0).toUpperCase() + remainingChars;
	  },
	  camelize: function(str) {
	    return str.trim().replace(/[-_\s]+(.)?/g, function(match, c) {
	      if (c) {
	        return c.toUpperCase();
	      } else {
	        return "";
	      }
	    });
	  },
	  titleize: function(str) {
	    str = str.toString();
	    return str.toLowerCase().replace(/(?:^|\s|-)\S/g, function(c) {
	      return c.toUpperCase();
	    });
	  },
	  humanize: function(str) {
	    return this.capitalize(_underscored(str).replace(/_id$/, "").replace(/_/g, " ")).trim();
	  },
	  formatAlias: function(str) {
	    return this.capitalize(this.humanize(str));
	  },
	  classify: function(str) {
	    str = str.toString();
	    return this.capitalize(this.camelize(str.replace(/[\W_]/g, " ")).replace(/\s/g, ""));
	  }
	};

	module.exports = CommentMixin;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var Address, Helpers, Profile, Schema, Work, _,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	_ = __webpack_require__(2);

	Helpers = __webpack_require__(7);

	Address = __webpack_require__(1);

	Work = __webpack_require__(17);

	Schema = __webpack_require__(18);

	Profile = function() {
	  var _importerPropertyMap, _loopProperties, _makeArray, _toObject, _top_field_options, api;
	  _loopProperties = function(field, callback) {
	    return _.each(field, function(properties) {
	      return _.each(properties, callback);
	    });
	  };
	  _makeArray = function(element) {
	    if (_.isArray(element)) {
	      return element;
	    } else {
	      return [element];
	    }
	  };
	  _toObject = function(key, value, obj) {
	    if (obj == null) {
	      obj = {};
	    }
	    if (key != null) {
	      obj[key] = value;
	    }
	    return obj;
	  };
	  _importerPropertyMap = {
	    "gender": "Gender",
	    "ethnicity": "Ethnicity",
	    "sports": "Sports",
	    "activities": "Activities",
	    "remote_id": "Remote ID"
	  };
	  _top_field_options = [
	    {
	      label: "Remote ID",
	      value: "remote_id",
	      "default": true
	    }, {
	      label: "Gender",
	      value: "properties.gender"
	    }, {
	      label: "Ethnicity",
	      value: "properties.ethnicity"
	    }, {
	      label: "Constituency",
	      value: "constituencies",
	      "default": true
	    }, {
	      label: "Your Capacity Score",
	      value: "giving.capacity_score"
	    }, {
	      label: "Your Engagement Score",
	      value: "giving.engagement_score"
	    }, {
	      label: "Solicitation Codes",
	      value: "solicitation_codes",
	      "default": true
	    }, {
	      label: "Prospect Status",
	      value: "prospect_statuses",
	      "default": true
	    }, {
	      label: "Donor Score",
	      value: "giving.donor_score"
	    }, {
	      label: "Athletics",
	      value: "sports",
	      "default": true
	    }, {
	      label: "Activities",
	      value: "extracurricular_activities"
	    }
	  ];
	  return api = {
	    getAvatar: function(parsed_contact) {
	      var ref;
	      if (parsed_contact == null) {
	        parsed_contact = {};
	      }
	      return (ref = parsed_contact.extended) != null ? ref.profile_image_url : void 0;
	    },
	    getPrimaryLocationDisplay: function(parsed_contact) {
	      var location;
	      location = {
	        value: Address.getLastLineFormat(Address.getPrimary(parsed_contact))
	      };
	      return location;
	    },
	    getRoleWithYear: function(parsed_contact) {
	      var constituentProperties, role_string, roles, year;
	      if (parsed_contact.constituencies) {
	        roles = _.compact(_.map(parsed_contact.constituencies, function(field) {
	          var ref;
	          return field != null ? (ref = field.status) != null ? ref.value : void 0 : void 0;
	        }));
	      } else {
	        constituentProperties = ["constituency", "constituencies", "constituentcode", "consttype"];
	        _.each(constituentProperties, function(prop) {
	          var customField;
	          customField = parsed_contact[prop + "_list"];
	          if (customField) {
	            return roles = _.compact(_.map(customField, function(field) {
	              var ref;
	              return field != null ? (ref = field[prop]) != null ? ref.value : void 0 : void 0;
	            }));
	          }
	        });
	      }
	      role_string = _.isEmpty(roles) ? void 0 : roles.join(", ");
	      year = this.getClassOf(parsed_contact);
	      return (role_string || "") + (role_string && year ? " - " : "") + (year || "");
	    },
	    getClassOf: function(parsed_contact) {
	      var ref, ref1, year;
	      year = parsed_contact != null ? (ref = parsed_contact.properties) != null ? (ref1 = ref.year) != null ? ref1.value : void 0 : void 0 : void 0;
	      if (year) {
	        return "Class of " + year;
	      } else {
	        return void 0;
	      }
	    },
	    getDeceased: function(parsed_contact) {
	      var ref, ref1;
	      if (parsed_contact != null ? (ref = parsed_contact.properties) != null ? (ref1 = ref.deceased) != null ? ref1.value : void 0 : void 0 : void 0) {
	        return "Deceased";
	      }
	    },
	    getIsMentor: function(parsed_contact) {
	      var ref, ref1;
	      return (parsed_contact != null ? (ref = parsed_contact.properties) != null ? (ref1 = ref.mentor) != null ? ref1.value : void 0 : void 0 : void 0) || false;
	    },
	    getContactInfo: function(parsed_contact) {
	      return {
	        phones: _.compact(_.map(parsed_contact != null ? parsed_contact.phones : void 0, function(phone) {
	          var ref, ref1, ref2, ref3, ref4;
	          if (phone != null ? (ref = phone.phone) != null ? ref.value : void 0 : void 0) {
	            return {
	              type: phone != null ? (ref1 = phone.type) != null ? ref1.value : void 0 : void 0,
	              phone: phone != null ? (ref2 = phone.phone) != null ? ref2.value : void 0 : void 0,
	              primary: phone != null ? (ref3 = phone.primary) != null ? ref3.value : void 0 : void 0,
	              "private": phone != null ? (ref4 = phone.phone) != null ? ref4["private"] : void 0 : void 0
	            };
	          }
	        })),
	        emails: _.compact(_.map(parsed_contact != null ? parsed_contact.emails : void 0, function(email) {
	          var ref, ref1, ref2, ref3, ref4;
	          if (email != null ? (ref = email.email) != null ? ref.value : void 0 : void 0) {
	            return {
	              type: email != null ? (ref1 = email.type) != null ? ref1.value : void 0 : void 0,
	              email: email != null ? (ref2 = email.email) != null ? ref2.value : void 0 : void 0,
	              primary: email != null ? (ref3 = email.primary) != null ? ref3.value : void 0 : void 0,
	              "private": email != null ? (ref4 = email.email) != null ? ref4["private"] : void 0 : void 0
	            };
	          }
	        }))
	      };
	    },
	    getPrimaryContactInfo: function(parsed_contact) {
	      var contact_info, primary_email, primary_phone;
	      contact_info = this.getContactInfo(parsed_contact);
	      primary_email = _.findWhere(contact_info.emails, {
	        primary: true
	      });
	      primary_phone = _.findWhere(contact_info.phones, {
	        primary: true
	      });
	      if (primary_email == null) {
	        primary_email = _.first(contact_info.emails);
	      }
	      if (primary_phone == null) {
	        primary_phone = _.first(contact_info.phones);
	      }
	      return {
	        phone: primary_phone,
	        email: primary_email
	      };
	    },
	    getParsedEducation: function(parsed_contact) {
	      if (_.isArray(parsed_contact != null ? parsed_contact.educations : void 0)) {
	        return _.map(parsed_contact.educations, function(education) {
	          var degree, degree_in_major, major, ref, ref1, ref2, ref3, ref4;
	          degree = education != null ? (ref = education.degree_key) != null ? ref.value : void 0 : void 0;
	          major = education != null ? (ref1 = education.majors) != null ? ref1.value : void 0 : void 0;
	          if (degree && major) {
	            degree_in_major = degree + " in " + major;
	          } else if (degree || major) {
	            degree_in_major = degree || major;
	          }
	          return {
	            school_name: education != null ? (ref2 = education.school_name) != null ? ref2.value : void 0 : void 0,
	            degree_key: degree,
	            majors: major,
	            degree_in_major: degree_in_major,
	            year: education != null ? (ref3 = education.year) != null ? ref3.value : void 0 : void 0,
	            "private": education != null ? (ref4 = education.school_name) != null ? ref4["private"] : void 0 : void 0
	          };
	        });
	      } else {
	        return [];
	      }
	    },
	    getMoreInfo: function(parsed_contact, parsed_schema, options) {
	      var contact_fields, fields, ref, ref1, remote_id;
	      if (parsed_contact == null) {
	        parsed_contact = {};
	      }
	      if (options == null) {
	        options = {};
	      }
	      contact_fields = parsed_contact.customs || {};
	      remote_id = _.findWhere(parsed_contact.identities, {
	        type: "remote_id"
	      });
	      if (options.include_new_props) {
	        _.each(contact_fields, function(field, field_key) {
	          return _loopProperties(field, function(prop, prop_key) {
	            if (indexOf.call(_.keys(_importerPropertyMap), prop_key) >= 0) {
	              return contact_fields = _.omit(contact_fields, field_key);
	            }
	          });
	        });
	        _.extend(contact_fields, Helpers.compactObject({
	          gender: [
	            {
	              gender: (ref = parsed_contact.properties) != null ? ref.gender : void 0
	            }
	          ],
	          ethnicity: [
	            {
	              ethnicity: (ref1 = parsed_contact.properties) != null ? ref1.ethnicity : void 0
	            }
	          ],
	          sports: parsed_contact.sports,
	          activities: parsed_contact.extracurricular_activities
	        }));
	      }
	      fields = _.compact(_.map(contact_fields, function(prop_fields, field_key) {
	        var data;
	        data = {
	          id: field_key,
	          labels: [],
	          values: []
	        };
	        _loopProperties(prop_fields, function(prop, key) {
	          var label, ref2;
	          label = _importerPropertyMap[prop != null ? prop.name : void 0] || _importerPropertyMap[field_key];
	          if (label == null) {
	            label = (ref2 = parsed_schema[field_key + "." + key]) != null ? ref2.description : void 0;
	          }
	          if (label && !_.contains(data.labels, label)) {
	            data.labels.push(label);
	          }
	          if ((prop != null ? prop.value : void 0) && (prop != null ? prop.value : void 0) !== " ") {
	            data.values.push(prop != null ? prop.value : void 0);
	          }
	          return data.type = prop != null ? prop.object_type : void 0;
	        });
	        if (!_.isEmpty(data.labels) && !_.isEmpty(data.values)) {
	          return data;
	        }
	      }));
	      fields = _.sortBy(fields, function(field) {
	        return _.first(field.labels);
	      });
	      if (remote_id) {
	        fields.unshift({
	          id: "remote_id",
	          labels: ["Remote ID"],
	          values: [remote_id.value]
	        });
	      }
	      return fields;
	    },
	    hasFacebookMatch: function(parsed_contact, lids_profile) {
	      var facebook_uid, ref, ref1;
	      if (parsed_contact == null) {
	        parsed_contact = {};
	      }
	      if (lids_profile == null) {
	        lids_profile = {};
	      }
	      facebook_uid = _.findWhere(parsed_contact != null ? parsed_contact.identities : void 0, {
	        type: "facebook_id"
	      });
	      return !!((facebook_uid != null ? facebook_uid.value : void 0) || (lids_profile != null ? (ref = lids_profile.facebook) != null ? (ref1 = ref.identities) != null ? ref1.facebook_id : void 0 : void 0 : void 0));
	    },
	    getIsPartiallyPrivate: function(parsed_contact) {
	      var ref, ref1;
	      return (_.any(_.pluck(Address.getAddresses(parsed_contact), "address_1"), {
	        "private": true
	      })) || (_.any((ref = this.getContactInfo(parsed_contact)) != null ? ref.phones : void 0, {
	        "private": true
	      })) || (_.any((ref1 = this.getContactInfo(parsed_contact)) != null ? ref1.emails : void 0, {
	        "private": true
	      })) || (_.any(this.getParsedEducation(parsed_contact), {
	        "private": true
	      })) || (_.any(Work.getAllPositions(parsed_contact), {
	        "private": true
	      }));
	    },
	    getTopFields: function(dna_fields, schema) {
	      var custom_options, options;
	      if (dna_fields == null) {
	        dna_fields = [];
	      }
	      if (schema == null) {
	        schema = [];
	      }
	      if (_.isEmpty(dna_fields)) {
	        return _.where(_top_field_options, {
	          "default": true
	        });
	      } else {
	        custom_options = _.map(Schema.getCustomFields(schema), function(field, key) {
	          return {
	            label: field.description,
	            value: "customs." + field.list_name
	          };
	        });
	        options = custom_options.concat(_.clone(_top_field_options));
	        return _.compact(_.map(dna_fields, function(field) {
	          var field_config;
	          field_config = _.findWhere(options, {
	            value: field
	          });
	          if (field_config) {
	            return {
	              label: field_config.label,
	              value: field
	            };
	          } else {
	            return null;
	          }
	        }));
	      }
	    },
	    getTopFieldsWithContactValues: function(parsed_contact, dna_fields, schema) {
	      var fields;
	      if (parsed_contact == null) {
	        parsed_contact = {};
	      }
	      if (dna_fields == null) {
	        dna_fields = [];
	      }
	      if (schema == null) {
	        schema = [];
	      }
	      fields = this.getTopFields(dna_fields, schema);
	      return _.map(fields, function(field) {
	        var display_value, field_path, field_val, ref;
	        if (field.value === "remote_id") {
	          field_val = _.findWhere(parsed_contact.identities, {
	            type: "remote_id"
	          });
	          if (field_val != null ? field_val.value : void 0) {
	            display_value = [field_val != null ? field_val.value : void 0];
	          }
	        } else {
	          field_path = (ref = field.value) != null ? typeof ref.split === "function" ? ref.split(".") : void 0 : void 0;
	          field_val = _.reduce(field_path, (function(memo, path) {
	            return memo != null ? memo[path] : void 0;
	          }), parsed_contact);
	          if (_.contains(field_path, "properties")) {
	            field_val = [
	              {
	                properties: field_val
	              }
	            ];
	          } else if (_.isObject(field_val) && !_.isArray(field_val)) {
	            field_val = _toObject(_.last(field_path), field_val);
	          }
	          display_value = _.flatten(_.compact(_.map(_makeArray(field_val), function(value_list) {
	            return _.compact(_.map(value_list, function(value_object) {
	              var value;
	              value = value_object != null ? value_object.value : void 0;
	              if (!_.isUndefined(value)) {
	                if ((value_object != null ? value_object.object_type : void 0) === "boolean") {
	                  value = value ? "Y" : "N";
	                }
	              }
	              if (_.isString(value)) {
	                if (!_.isEmpty(value.trim())) {
	                  return value.trim();
	                }
	              } else {
	                return value;
	              }
	            }));
	          })));
	        }
	        if (field.label) {
	          return {
	            label: field.label,
	            key: field.value,
	            value: _.isEmpty(display_value) ? void 0 : display_value
	          };
	        }
	      });
	    }
	  };
	};

	module.exports = Profile();


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var Helpers, Work, _;

	_ = __webpack_require__(2);

	Helpers = __webpack_require__(7);

	Work = function() {
	  var _formatIndustry, _formatPositions, api;
	  _formatPositions = function(positions) {
	    if (_.isArray(positions)) {
	      return _.map(positions, function(company) {
	        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
	        return Helpers.compactObject({
	          name: (company != null ? (ref = company.company_name) != null ? ref.value : void 0 : void 0) || (company != null ? (ref1 = company.company) != null ? ref1.value : void 0 : void 0) || (company != null ? (ref2 = company.company) != null ? ref2.name : void 0 : void 0),
	          title: (company != null ? (ref3 = company.title) != null ? ref3.value : void 0 : void 0) || (company != null ? company.title : void 0),
	          "function": (company != null ? (ref4 = company["function"]) != null ? ref4.value : void 0 : void 0) || (company != null ? company["function"] : void 0),
	          id: (company != null ? (ref5 = company.company_id) != null ? ref5.value : void 0 : void 0) || (company != null ? (ref6 = company.company) != null ? ref6.id : void 0 : void 0),
	          industry: _formatIndustry(company),
	          "private": company != null ? (ref7 = company.company) != null ? ref7["private"] : void 0 : void 0
	        });
	      });
	    } else {
	      return [];
	    }
	  };
	  _formatIndustry = function(company) {
	    var ref;
	    if (_.isObject(company != null ? (ref = company.company) != null ? ref.industry : void 0 : void 0)) {
	      return company.company.industry.description;
	    } else if (_.isObject(company != null ? company.industry : void 0)) {
	      return company.industry.value;
	    } else if (_.isObject(company != null ? company.industry_description : void 0)) {
	      return company.industry_description.value;
	    } else {
	      return company != null ? company.industry : void 0;
	    }
	  };
	  return api = {
	    getCurrentCompany: function(parsed_contact) {
	      var position;
	      if (parsed_contact == null) {
	        parsed_contact = {};
	      }
	      if (!position) {
	        position = _.first(parsed_contact.employments);
	      }
	      return _.first(_formatPositions([position]));
	    },
	    getAllPositions: function(parsed_contact) {
	      var positions;
	      if (parsed_contact == null) {
	        parsed_contact = {};
	      }
	      positions = _formatPositions(parsed_contact.employments);
	      return _.sortBy(_.flatten(positions), "name");
	    }
	  };
	};

	module.exports = Work();


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var Helpers, Schema, _;

	_ = __webpack_require__(2);

	Helpers = __webpack_require__(7);

	Schema = function() {
	  var _propertyLoop, api;
	  _propertyLoop = function(schema, callback) {
	    return _.each(_.extend({}, schema), function(list) {
	      var parent, properties, ref, ref1;
	      parent = Helpers.cloneData(list);
	      if ((ref = list.containing_object) != null ? ref.properties : void 0) {
	        properties = list.containing_object.properties;
	      } else if (list.properties) {
	        properties = list.properties;
	      } else {
	        properties = [list];
	      }
	      if ((ref1 = parent.containing_object) != null ? ref1.properties : void 0) {
	        delete parent.containing_object.properties;
	      }
	      return _.each(_.map(properties, _.clone), function(prop) {
	        prop.list_name = list.name;
	        prop.object_name = (list.containing_object ? list.containing_object.name : void 0);
	        prop.parent_object = _.extend({}, parent);
	        return callback(list, prop);
	      });
	    });
	  };
	  return api = {
	    parse: function(property_schema) {
	      var lookup;
	      lookup = {};
	      _propertyLoop(property_schema, function(list, prop) {
	        if (prop.name === "value") {
	          return lookup[prop.list_name] = prop;
	        } else {
	          return lookup[prop.list_name + "." + prop.name] = prop;
	        }
	      });
	      return lookup;
	    },
	    getCustomFields: function(property_schema, data) {
	      var flex;
	      if (data == null) {
	        data = {};
	      }
	      flex = [];
	      _propertyLoop(property_schema, function(list, prop) {
	        if (!Helpers.toBoolean(list["default"]) && !Helpers.toBoolean(list["deleted"])) {
	          return flex.push(list);
	        }
	      });
	      if (_.isEmpty(data)) {
	        return this.parse(flex);
	      } else {
	        return this.filterPermission(flex, data);
	      }
	    },
	    filterPermission: function(property_schema, data) {
	      var fields, filtered;
	      fields = this.parse(property_schema);
	      filtered = {};
	      _.each(fields, (function(_this) {
	        return function(field, key) {
	          if (_this.checkAccess(field, data)) {
	            return filtered[key] = field;
	          }
	        };
	      })(this));
	      return filtered;
	    },
	    checkAccess: function(field, data) {
	      var app, permissions, ref, write_permission;
	      if (data == null) {
	        data = {};
	      }
	      if (!field) {
	        return false;
	      }
	      if (field.deleted || ((ref = field.parent_object) != null ? ref.deleted : void 0)) {
	        return false;
	      }
	      if (!data.app_key || !data.roles || !data.oid) {
	        console.warn("Decorator.Schema.checkAccess(field, data) requires data to be an object containing 'app_key', 'roles', and 'oid'");
	        return false;
	      }
	      app = _.contains(field.app_keys, data.app_key);
	      if (data.super_user) {
	        permissions = [{}];
	      } else {
	        permissions = _.filter(field.permissions, function(perm) {
	          return _.contains(data.roles, perm.actor_role_id);
	        });
	      }
	      if (data.writable) {
	        write_permission = _.any(permissions, function(perm) {
	          return perm.writable;
	        });
	        return (!_.isEmpty(permissions)) && app && write_permission;
	      } else {
	        return (!_.isEmpty(permissions)) && app;
	      }
	    }
	  };
	};

	module.exports = Schema();


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var Lists, _,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	_ = __webpack_require__(2);

	Lists = function() {
	  var NOTE_TYPES, _activityIsNote, _compare, _compareDates, _formatDate, _formatLabel, _formatTarget, _getAdditionalOffset, _wrap, api;
	  NOTE_TYPES = ["evertrue comment"];
	  _activityIsNote = function(activity) {
	    var ref, ref1;
	    return ref = activity != null ? (ref1 = activity.interaction_type) != null ? ref1.toLowerCase() : void 0 : void 0, indexOf.call(NOTE_TYPES, ref) >= 0;
	  };
	  _formatLabel = function(activity) {
	    var label, length, ref, ref1;
	    if (_activityIsNote(activity)) {
	      return "added a note";
	    }
	    label = (ref = activity.type) != null ? typeof ref.toLowerCase === "function" ? ref.toLowerCase() : void 0 : void 0;
	    if (label === "deleted") {
	      label = "removed";
	    }
	    length = activity.total || ((ref1 = activity.activities) != null ? ref1.length : void 0);
	    label += " " + (length > 1 ? length : "a");
	    return label += " " + _formatTarget(activity.target, length > 1);
	  };
	  _formatTarget = function(target, plural) {
	    var output;
	    output = target != null ? target.toLowerCase() : void 0;
	    if (output === "contact") {
	      output = "constituent";
	    }
	    if (plural) {
	      output += "s";
	    }
	    return output;
	  };
	  _formatDate = function(timestamp) {
	    var date;
	    date = new Date(timestamp);
	    return date.getMonth() + "-" + date.getDay() + "-" + date.getFullYear();
	  };
	  _compareDates = function(date_1, date_2) {
	    return _formatDate(date_1) === _formatDate(date_2);
	  };
	  _compare = function(prev, next) {
	    var ref;
	    return ((ref = next.target) === "COLLABORATOR" || ref === "CONTACT") && prev.user_id === next.user_id && prev.target === next.target && !!next.target && prev.type === next.type && _compareDates(prev.created_at, next.created_at);
	  };
	  _getAdditionalOffset = function(response, aggregation) {
	    if (response.total > (response.offset + response.limit)) {
	      if (aggregation.length < 10) {
	        return response.offset + Math.min(response.total - response.offset, response.limit);
	      }
	    }
	  };
	  _wrap = function(item) {
	    return {
	      type: _activityIsNote(item) ? "NOTE" : "ACTIVITY",
	      value: item
	    };
	  };
	  return api = {
	    getTargetData: function(list_api_response) {
	      var data;
	      data = {
	        users: []
	      };
	      _.map(list_api_response != null ? list_api_response.items : void 0, function(activity) {
	        var name;
	        if (activity.target) {
	          if (data[name = activity.target.toLowerCase()] == null) {
	            data[name] = [];
	          }
	          data[activity.target.toLowerCase()].push(activity.target_id);
	        }
	        if (activity.user_id) {
	          return data.users.push(activity.user_id);
	        }
	      });
	      _.each(data, function(group, key) {
	        return data[key] = _.uniq(group);
	      });
	      return data;
	    },
	    getActivityLabel: function(activity) {
	      return _formatLabel(activity);
	    },
	    getAggregation: function(list_api_response, ugc_api_response) {
	      var aggregation, data, items, ref;
	      aggregation = [];
	      items = _.compact(_.flatten([list_api_response != null ? list_api_response.items : void 0, ugc_api_response != null ? ugc_api_response.items : void 0]));
	      items = (ref = _.sortBy(items, "created_at")) != null ? ref.reverse() : void 0;
	      _.each(items, function(item) {
	        var data, prev_item, ref1;
	        prev_item = (ref1 = _.last(aggregation)) != null ? ref1.value : void 0;
	        if (prev_item && _compare(prev_item, item)) {
	          return prev_item.activities.push(item);
	        } else if (item.target && !item.interaction_type) {
	          data = _.extend({}, item, {
	            activities: [_.extend({}, item)]
	          });
	          return aggregation.push(_wrap(data));
	        } else {
	          return aggregation.push(_wrap(item));
	        }
	      });
	      _.each(aggregation, function(activity) {
	        activity.value.label = _formatLabel(activity.value);
	        if (activity.type === "ACTIVITY") {
	          return _.map(activity.value.activities, function(item) {
	            return item.label = activity.label;
	          });
	        }
	      });
	      return data = {
	        load_additional_offset: _getAdditionalOffset(list_api_response, aggregation),
	        items: aggregation
	      };
	    }
	  };
	};

	module.exports = Lists();


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var ChildDoc, EXCLUDE_TYPES, Helpers, MyPortfolio, Parameter, Property, Query, _;

	_ = __webpack_require__(2);

	Helpers = __webpack_require__(7);

	Query = __webpack_require__(5);

	Parameter = __webpack_require__(6);

	Property = __webpack_require__(8);

	ChildDoc = __webpack_require__(13);

	EXCLUDE_TYPES = ["Note", "EverTrue Comment"];

	MyPortfolio = function() {
	  var _filters, _getChildProspectStatusObj, _getCompleteQuery, _getFullQuery, _getLastContactChild, _getQuery, _getSortChildQuery, _getSortQuery, _getTimeInStageChild, _getTotalProspectStatusParam, api;
	  _filters = {
	    map: function(bounds) {
	      return Query([
	        Parameter("must", [
	          Property("location", bounds, {
	            type: "object",
	            parent: "addresses",
	            parent_type: "instance"
	          })
	        ])
	      ]);
	    },
	    address_types: function(address_types) {
	      return Query([
	        Parameter("must", [
	          Property("type", address_types, {
	            type: "contains",
	            parent: "addresses",
	            parent_type: "instance"
	          })
	        ])
	      ]);
	    },
	    assignee: function(user_id) {
	      return Query([
	        Parameter("must", [
	          Property("user_id", user_id, {
	            type: "equals",
	            parent: "assignees",
	            parent_type: "instance"
	          })
	        ])
	      ]);
	    },
	    total_prospect_status: function(status_obj) {
	      return Query([
	        Parameter(status_obj.parameter, [
	          Property("status.untouched", status_obj.value, {
	            type: "contains",
	            parent: "assignees",
	            parent_type: "instance"
	          })
	        ])
	      ]);
	    },
	    single_prospect_status: function(status) {
	      if (status === "No Status") {
	        return Query([
	          Parameter("must", [
	            Property("status.untouched", false, {
	              type: "exists",
	              parent: "assignees",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      } else {
	        return Query([
	          Parameter("must", [
	            Property("status.untouched", status, {
	              type: "equals",
	              parent: "assignees",
	              parent_type: "instance"
	            })
	          ])
	        ]);
	      }
	    },
	    child_doc_sort: function(child_sort) {
	      return Query([
	        Parameter("sort", [
	          Property(child_sort, {
	            operation: "max"
	          }, {
	            type: "object"
	          })
	        ])
	      ]);
	    },
	    child_doc_assignee: function(user_id) {
	      return Query([
	        Parameter("must", [
	          Property("user_id", user_id, {
	            type: "equals",
	            parent: "current.assignees",
	            parent_type: "instance"
	          })
	        ]), Parameter("must_not", [
	          Property("user_id", user_id, {
	            type: "equals",
	            parent: "previous.assignees",
	            parent_type: "instance"
	          })
	        ])
	      ]);
	    },
	    child_doc_prospect_status: function(status) {
	      return Query([
	        Parameter("must", [
	          Property("status.untouched", status, {
	            type: "equals",
	            parent: "current.assignees",
	            parent_type: "instance"
	          })
	        ]), Parameter("must_not", [
	          Property("status.untouched", status, {
	            type: "equals",
	            parent: "previous.assignees",
	            parent_type: "instance"
	          })
	        ])
	      ]);
	    },
	    contact_activity_child_doc: function(child_doc_query) {
	      return Query([Parameter("should", [ChildDoc("contact_activity", child_doc_query)])]);
	    },
	    contact_note_child_doc: function(child_doc_query) {
	      return Query([Parameter("should", [ChildDoc("contact_note", child_doc_query)])]);
	    },
	    date_occurred: function(obj) {
	      return Query([
	        Parameter("must", [
	          Property("date_occurred", obj, {
	            type: "object"
	          })
	        ])
	      ]);
	    },
	    note_type: function(types) {
	      return Query([
	        Parameter("must_not", [
	          Property("interaction_type.untouched", types, {
	            type: "contains"
	          })
	        ])
	      ]);
	    }
	  };
	  _getFullQuery = function(filters) {
	    var fullQuery;
	    fullQuery = Query();
	    _.each(filters, function(filter, key) {
	      if ((_.isObject(filter) && !_.isEmpty(filter)) || (!_.isObject(filter) && filter)) {
	        return fullQuery.merge(_filters[key](filter));
	      }
	    });
	    return fullQuery;
	  };
	  _getQuery = function(filters) {
	    var ref;
	    return (ref = _getFullQuery(filters)) != null ? ref.toJSON() : void 0;
	  };
	  _getTotalProspectStatusParam = function(data) {
	    var not_included_cols;
	    if (_.contains(data.active_columns, "No Status")) {
	      not_included_cols = _.difference(data.all_columns, data.active_columns);
	      if (!_.isEmpty(not_included_cols)) {
	        return {
	          parameter: "must_not",
	          value: not_included_cols
	        };
	      }
	    } else {
	      return {
	        parameter: "must",
	        value: data.active_columns
	      };
	    }
	  };
	  _getSortChildQuery = function(user_id, data) {
	    var sort_param_prop;
	    if (data.sort_param_prop) {
	      sort_param_prop = data.sort_param_prop;
	    } else if (data.sort_param) {
	      sort_param_prop = _.keys(data.sort_param)[0];
	    }
	    if (sort_param_prop === "time_in_stage") {
	      return _getTimeInStageChild(user_id, data.status);
	    } else if (sort_param_prop === "last_contact_date") {
	      return _getLastContactChild();
	    }
	  };
	  _getTimeInStageChild = function(user_id, status) {
	    var child_doc_obj, child_doc_query;
	    child_doc_obj = _getChildProspectStatusObj(user_id, status, "created_at");
	    child_doc_query = _getFullQuery(child_doc_obj);
	    return _getQuery({
	      contact_activity_child_doc: child_doc_query
	    });
	  };
	  _getLastContactChild = function() {
	    var child_doc_query, note_obj;
	    note_obj = {
	      note_type: EXCLUDE_TYPES,
	      date_occurred: {
	        "lte": "now"
	      },
	      child_doc_sort: "date_occurred"
	    };
	    child_doc_query = _getFullQuery(note_obj);
	    return _getQuery({
	      contact_note_child_doc: child_doc_query
	    });
	  };
	  _getChildProspectStatusObj = function(user_id, status, sort_param_prop) {
	    var child_doc_obj;
	    child_doc_obj = {
	      child_doc_assignee: user_id
	    };
	    if (status && (status !== "No Status")) {
	      _.extend(child_doc_obj, {
	        child_doc_prospect_status: status
	      });
	    }
	    if (sort_param_prop) {
	      _.extend(child_doc_obj, {
	        child_doc_sort: sort_param_prop
	      });
	    }
	    return child_doc_obj;
	  };
	  _getSortQuery = function(sort_param) {
	    var ref, sort_param_prop, sort_param_reverse;
	    sort_param_prop = _.keys(sort_param)[0];
	    sort_param_reverse = (ref = _.values(sort_param)[0]) != null ? ref.order : void 0;
	    if (sort_param_prop === "time_in_stage" || sort_param_prop === "last_contact_date") {
	      return Helpers.toObject("_score", {
	        order: sort_param_reverse
	      });
	    } else if (sort_param) {
	      return sort_param;
	    }
	  };
	  _getCompleteQuery = function(query, child_query, sort_param) {
	    if (child_query) {
	      query = Helpers.deepObjectExtend(query, child_query);
	    }
	    if (sort_param) {
	      query.sort = [_getSortQuery(sort_param)];
	    }
	    return query;
	  };
	  return api = {
	    getTotalProspectsQuery: function(user_id, data) {
	      var prospect_obj, query_obj;
	      query_obj = {
	        assignee: user_id
	      };
	      prospect_obj = _getTotalProspectStatusParam(data);
	      if (prospect_obj) {
	        _.extend(query_obj, {
	          total_prospect_status: prospect_obj
	        });
	      }
	      return _getQuery(query_obj);
	    },
	    getProspectsByStatusQuery: function(user_id, data) {
	      var base_query, child_query;
	      base_query = _getQuery({
	        single_prospect_status: data.status,
	        assignee: user_id
	      });
	      child_query = _getSortChildQuery(user_id, data);
	      return _getCompleteQuery(base_query, child_query, data.sort_param);
	    },
	    getMapQuery: function(user_id, data) {
	      var base_query, child_query, prospect_obj, query_obj;
	      query_obj = {
	        map: data.bounds,
	        assignee: user_id
	      };
	      prospect_obj = _getTotalProspectStatusParam(data);
	      if (prospect_obj) {
	        _.extend(query_obj, {
	          total_prospect_status: prospect_obj
	        });
	      }
	      if (data.address_types) {
	        _.extend(query_obj, {
	          address_types: data.address_types
	        });
	      }
	      base_query = _getQuery(query_obj);
	      child_query = _getSortChildQuery(data.user_id, data);
	      return _getCompleteQuery(base_query, child_query, data.sort_param);
	    },
	    getFilters: function(filters) {
	      return _filters(filters);
	    },
	    getQuery: function(filters) {
	      return _getQuery(filters);
	    },
	    getTotalProspectStatusParam: function(data) {
	      return _getTotalProspectStatusParam(data);
	    },
	    getLastMoveQuery: function(user_id, status) {
	      var query_obj;
	      query_obj = _getChildProspectStatusObj(user_id, status);
	      return _getQuery(query_obj);
	    }
	  };
	};

	module.exports = MyPortfolio();


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var Helpers, MyTrips, _, moment, momentTimezone;

	_ = __webpack_require__(2);

	Helpers = __webpack_require__(7);

	moment = __webpack_require__(12);

	momentTimezone = __webpack_require__(22);

	MyTrips = function() {
	  var _formatDateObjects, _round, api;
	  api = {};
	  _round = function(n, decimal_place) {
	    if (decimal_place) {
	      return Math.round(n * decimal_place) / decimal_place;
	    } else {
	      return Math.round(n);
	    }
	  };
	  _formatDateObjects = function(object, zone) {
	    return _.extend({}, object, {
	      start_datetime: {
	        time_string: api.getTime(object.start_at, zone),
	        date_string: api.getDate(object.start_at, zone),
	        timezone_display: zone ? moment(object.start_at).tz(zone).format("z") : void 0
	      },
	      end_datetime: {
	        time_string: api.getTime(object.end_at, zone),
	        date_string: api.getDate(object.end_at, zone),
	        timezone_display: zone ? moment(object.end_at).tz(zone).format("z") : void 0
	      }
	    });
	  };
	  return _.extend(api, {
	    parse: function(trip) {
	      var ref, zone;
	      zone = (ref = trip.location) != null ? ref.timezone_id : void 0;
	      return _formatDateObjects(trip, zone);
	    },
	    parseMeeting: function(meeting) {
	      var ref, zone;
	      zone = (ref = meeting.location) != null ? ref.timezone_id : void 0;
	      return _formatDateObjects(meeting, zone);
	    },
	    hasValidTimeRange: function(start, end) {
	      return moment(end, "h:mm a").diff(moment(start, "h:mm a"), "minutes") > 0;
	    },
	    hasValidTripRange: function(trip, meetings) {
	      var meetings_end, meetings_end_date, meetings_start_time, ref, trip_end_date;
	      if (!trip.id) {
	        return true;
	      } else if (_.isEmpty(meetings)) {
	        return true;
	      } else {
	        meetings_start_time = _.min(_.pluck(meetings, "start_at"));
	        meetings_end = _.max(meetings, "end_at");
	        meetings_end_date = this.getDate(meetings_end.end_at, meetings_end != null ? (ref = meetings_end.location) != null ? ref.timezone_id : void 0 : void 0);
	        trip_end_date = moment(trip.end_at).format("YYYY-MM-DD");
	        return meetings_start_time >= trip.start_at && meetings_end_date <= trip_end_date;
	      }
	    },
	    getDate: function(date, zone, format) {
	      if (format == null) {
	        format = "YYYY-MM-DD";
	      }
	      if (zone) {
	        return moment(date).tz(zone).format(format);
	      } else {
	        return moment(date).format(format);
	      }
	    },
	    getTime: function(date, zone, format) {
	      if (format == null) {
	        format = "h:mm a";
	      }
	      if (zone) {
	        return moment(date).tz(zone).format(format);
	      } else {
	        return moment(date).format(format);
	      }
	    },
	    getUTCTimestamp: function(date, time, zoneOffset) {
	      var full_time;
	      full_time = moment(time, "h:mm a").format("HH:mm:ss");
	      return moment.utc(date + "T" + full_time + zoneOffset).valueOf();
	    },
	    getTripTimestamps: function(from, to) {
	      return {
	        start_at: moment(from).utc().valueOf(),
	        end_at: moment(to + "T23:59:59").utc().valueOf()
	      };
	    },
	    getTimeBetween: function(next, current) {
	      var minutes_diff, ms_difference;
	      if (next) {
	        ms_difference = next.start_at - current.end_at;
	        minutes_diff = (ms_difference / 1000) / 60;
	        if (minutes_diff < 0) {
	          return "Meetings Overlap";
	        } else {
	          return this.getFormattedTime(ms_difference / 1000);
	        }
	      }
	    },
	    getFormattedTime: function(seconds) {
	      var hours, min;
	      min = seconds / 60;
	      if (min >= 60) {
	        hours = _round(min / 60, 10);
	        if (hours === 1) {
	          return hours + " hr";
	        } else {
	          return hours + " hrs";
	        }
	      } else {
	        return (Math.round(min)) + " min";
	      }
	    },
	    getFormattedDistance: function(meters) {
	      var miles;
	      miles = meters * 0.000621371192;
	      if (miles < .1) {
	        return (_round(meters / 0.3048)) + " ft";
	      } else if (miles >= 100) {
	        return (_round(miles)) + " mi";
	      } else {
	        return (_round(miles, 10)) + " mi";
	      }
	    },
	    getDriveDisplay: function(distance, time) {
	      time = this.getFormattedTime(time);
	      distance = this.getFormattedDistance(distance);
	      return time + " drive (" + distance + ")";
	    },
	    getCalendarData: function(trip, meetings) {
	      var days, i, meetings_by_date, number_of_days, results, sorted_meetings;
	      if (trip) {
	        number_of_days = moment(trip.end_at).diff(trip.start_at, "days");
	        days = _.map((function() {
	          results = [];
	          for (var i = 0; 0 <= number_of_days ? i <= number_of_days : i >= number_of_days; 0 <= number_of_days ? i++ : i--){ results.push(i); }
	          return results;
	        }).apply(this), function(n) {
	          return moment(trip.start_at).add(n, "days").format("ddd MM/DD");
	        });
	      }
	      sorted_meetings = _.map(_.sortBy(meetings, "start_at"), (function(_this) {
	        return function(meeting) {
	          var ref, zone;
	          zone = meeting != null ? (ref = meeting.location) != null ? ref.timezone_id : void 0 : void 0;
	          return _.extend({}, meeting, {
	            display_day: _this.getDate(meeting.start_at, zone, "ddd MM/DD")
	          });
	        };
	      })(this));
	      meetings_by_date = {};
	      _.each(days, function(day) {
	        return meetings_by_date[day] = _.where(sorted_meetings, {
	          display_day: day
	        });
	      });
	      return meetings_by_date;
	    },
	    getFacepile: function(contacts, max_count) {
	      var all_avatars, facepile;
	      if (contacts == null) {
	        contacts = [];
	      }
	      if (max_count == null) {
	        max_count = 5;
	      }
	      all_avatars = _.sortBy(Helpers.cloneData(contacts), "avatar");
	      facepile = {
	        additional_count: 0,
	        contacts: _.first(all_avatars, max_count)
	      };
	      if (all_avatars.length > max_count) {
	        facepile.contacts = _.first(all_avatars, max_count - 1);
	        facepile.additional_count = all_avatars.length - max_count + 1;
	      }
	      return facepile;
	    },
	    getLocationDisplay: function(meeting) {
	      var address, location, name, string;
	      location = meeting.location || {};
	      if (!location.name && !location.formatted_address) {
	        return "No location added";
	      } else {
	        address = location.formatted_address;
	        if (!address.match(location.name)) {
	          name = location.name;
	        }
	        string = name || "";
	        if (name && address) {
	          string += ", ";
	        }
	        string += address || "";
	        return string;
	      }
	    }
	  });
	};

	module.exports = MyTrips();


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var Notifications, _;

	_ = __webpack_require__(2);

	Notifications = function() {
	  var api;
	  return api = {
	    getActivityType: function(noti) {
	      var ref, ref1, ref2, ref3, ref4, ref5, ref6, type;
	      type = noti != null ? (ref = noti.activity) != null ? ref.type : void 0 : void 0;
	      if (noti != null ? (ref1 = noti.activity) != null ? (ref2 = ref1.content) != null ? (ref3 = ref2.search) != null ? ref3.query : void 0 : void 0 : void 0 : void 0) {
	        type = "search_diff";
	      }
	      if ((noti != null ? (ref4 = noti.message) != null ? ref4.match("Facebook") : void 0 : void 0) && type === "search_query") {
	        type = "facebook";
	      }
	      if ((noti != null ? (ref5 = noti.message) != null ? (ref6 = ref5.toLowerCase()) != null ? ref6.match("linkedin") : void 0 : void 0 : void 0) && type === "search_query") {
	        type = "linkedin";
	      }
	      return type;
	    }
	  };
	};

	module.exports = Notifications();


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	const _ = __webpack_require__(2);
	const moment = __webpack_require__(12);

	const Org = function() {
	   const api = {
	      getGivingTreeRolesArray(org) {
	         const keys = {
	            owner: "GivingTree Owner",
	            user: "GivingTree User"
	         };

	         return _.compact(
	            _.map(keys, function(value, key) {
	               const { roles } = org;
	               const role = _.findWhere(roles, { name: value });
	               return role != null ? role.id : undefined;
	            })
	         );
	      },

	      // start_date is expected to come from dna in MM-DD format
	      getFiscalYearStart(start_date) {
	         const fiscal_start = start_date || "07-01";
	         const fiscal_date = `${moment().year()}-${fiscal_start}`;
	         const date = moment(fiscal_date);
	         return date.isAfter()
	            ? date.subtract(1, "years").format("YYYY-MM-DD")
	            : fiscal_date;
	      },

	      // start_date is expected to come from dna in MM-DD format
	      getFiscalYearEnd(start_date) {
	         const fiscalYearStart = this.getFiscalYearStart(start_date);
	         // end date should be one year ahead and one day less
	         // so if start date is 01-01-2020, end date should be 12-31-2020
	         return moment(fiscalYearStart)
	            .add(1, "years")
	            .subtract(1, "days")
	            .format("YYYY-MM-DD");
	      },

	      // start_date is expected to come from dna in MM-DD format
	      getDaysUntilFiscalYearEnd(start_date) {
	         const fiscalYearEnd = this.getFiscalYearEnd(start_date);
	         const fy_end = moment(fiscalYearEnd);
	         let daysUntilEndOfFy = fy_end.diff(moment.now(), "days");
	         if (daysUntilEndOfFy < 0) {
	            daysUntilEndOfFy = 0;
	         }
	         return daysUntilEndOfFy;
	      }
	   };

	   return api;
	};

	module.exports = Org();


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  Query: __webpack_require__(5),
	  Parameter: __webpack_require__(6),
	  Property: __webpack_require__(8),
	  Operator: __webpack_require__(9),
	  ChildDoc: __webpack_require__(13),
	  FilterConfig: __webpack_require__(11)
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var Org, Parameter, Property, Query, User, _;

	_ = __webpack_require__(2);

	Org = __webpack_require__(24);

	Query = __webpack_require__(5);

	Parameter = __webpack_require__(6);

	Property = __webpack_require__(8);

	User = function() {
	  var api;
	  return api = {
	    getName: function(user_data, current_user_id) {
	      if (user_data == null) {
	        user_data = {};
	      }
	      if (user_data.id === current_user_id) {
	        return "You";
	      } else {
	        return user_data.name;
	      }
	    },
	    getAffiliationFor: function(user, org_id) {
	      if (user == null) {
	        user = {};
	      }
	      return _.find(user.affiliations, function(affiliation) {
	        var oid, ref;
	        oid = ((ref = affiliation.organization) != null ? ref.id : void 0) || affiliation.organization_id;
	        return oid === org_id;
	      });
	    },
	    getRoles: function(user, org_id) {
	      var affil;
	      if (user == null) {
	        user = {};
	      }
	      affil = this.getAffiliationFor(user, org_id);
	      return _.map(affil != null ? affil.affiliation_roles : void 0, function(role) {
	        var ref, ref1;
	        return {
	          id: ((ref = role.role) != null ? ref.id : void 0) || role.role_id,
	          name: (ref1 = role.role) != null ? ref1.name : void 0
	        };
	      });
	    },
	    getContactId: function(user, org_id) {
	      var affil;
	      if (user == null) {
	        user = {};
	      }
	      affil = this.getAffiliationFor(user, org_id);
	      return affil != null ? affil.contact_id : void 0;
	    },
	    hasAffiliationTo: function(user, org) {
	      if (user == null) {
	        user = {};
	      }
	      return !!this.getAffiliationFor(user, org);
	    },
	    isInternal: function(user) {
	      var has_evertrue_affil, ref;
	      if (user == null) {
	        user = {};
	      }
	      has_evertrue_affil = _.find(user.affiliations, function(affiliation) {
	        var ref;
	        return ((ref = affiliation.organization) != null ? ref.name : void 0) === "EverTrue";
	      });
	      return !!(has_evertrue_affil || ((ref = user.email) != null ? ref.match("@evertrue.com") : void 0));
	    },
	    getUsersSearchQuery: function(name, roles_array) {
	      return Query([
	        Parameter("must", [
	          Property("name", name, {
	            type: "wildcard"
	          }), Property("affiliations.affiliation_roles.role_id", roles_array, {
	            type: "contains"
	          })
	        ])
	      ]);
	    },
	    isOwner: function(user, org_id) {
	      var roles;
	      roles = this.getRoles(user, org_id);
	      return Boolean(roles.find(function(role) {
	        var ref;
	        return role != null ? (ref = role.name) != null ? ref.toLowerCase().includes("owner") : void 0 : void 0;
	      }));
	    }
	  };
	};

	module.exports = User();


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var Enrichment, MIGHT_SCORE_FLOOR, PROBABLY_SCORE_FLOOR, _;

	_ = __webpack_require__(2);

	PROBABLY_SCORE_FLOOR = 60;

	MIGHT_SCORE_FLOOR = 30;

	Enrichment = function() {
	  var _getAdditionalInterests, _getMightInterests, _getProbablyInterests, _sortByHighest, api;
	  _sortByHighest = function(interests) {
	    return _.sortBy(interests, "confidence_score").reverse();
	  };
	  _getProbablyInterests = function(interests) {
	    return _sortByHighest(_.filter(interests, function(interest) {
	      return interest.confidence_score >= PROBABLY_SCORE_FLOOR;
	    }));
	  };
	  _getMightInterests = function(interests) {
	    return _sortByHighest(_.filter(interests, function(interest) {
	      return interest.confidence_score >= MIGHT_SCORE_FLOOR && interest.confidence_score < PROBABLY_SCORE_FLOOR;
	    }));
	  };
	  _getAdditionalInterests = function(interests) {
	    return _sortByHighest(_.filter(interests, function(interest) {
	      return interest.confidence_score < MIGHT_SCORE_FLOOR;
	    }));
	  };
	  return api = {
	    getProbablyInterests: function(interests) {
	      return _getProbablyInterests(interests);
	    },
	    getMightInterests: function(interests) {
	      return _getMightInterests(interests);
	    },
	    getAdditionalInterests: function(interests) {
	      return _getAdditionalInterests(interests);
	    },
	    getRankedInterests: function(interests) {
	      var additionalInterests, mightInterests, probablyInterests;
	      probablyInterests = _getProbablyInterests(interests);
	      mightInterests = _getMightInterests(interests);
	      additionalInterests = _getAdditionalInterests(interests);
	      return {
	        probably: probablyInterests,
	        might: mightInterests,
	        additional: additionalInterests,
	        all: _sortByHighest(interests)
	      };
	    }
	  };
	};

	module.exports = Enrichment();


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var Contacts, Profile, _, formatRelationship, getContactInfo, getFirstName, getInferredRelationshipType, getRemoteId, getSortedRelationships, getSortedVMSRelationships, indexByRemoteId, parseRelationships, ref;

	_ = __webpack_require__(2);

	Contacts = __webpack_require__(3);

	Profile = __webpack_require__(16);

	ref = __webpack_require__(29), getSortedVMSRelationships = ref.getSortedVMSRelationships, getSortedRelationships = ref.getSortedRelationships;

	getRemoteId = function(contact) {
	  var ref1;
	  if (contact == null) {
	    contact = {};
	  }
	  return (ref1 = _.findWhere(contact.identities, {
	    type: "remote_id"
	  })) != null ? ref1.value : void 0;
	};

	getFirstName = function(contact) {
	  var ref1, ref2;
	  if (contact == null) {
	    contact = {};
	  }
	  return ((ref1 = contact.properties) != null ? (ref2 = ref1.name_first) != null ? ref2.value : void 0 : void 0) || "this constituent";
	};

	indexByRemoteId = function(list) {
	  if (list == null) {
	    list = [];
	  }
	  return _.indexBy(list, function(contact) {
	    if (contact == null) {
	      contact = {};
	    }
	    return getRemoteId(contact) || "no_remote_id";
	  });
	};

	parseRelationships = function(raw_relationships) {
	  if (_.isArray(raw_relationships)) {
	    return _.map(raw_relationships, function(rel) {
	      return _.mapObject(rel, function(property, key) {
	        return (property != null ? property.value : void 0) || property;
	      });
	    });
	  } else {
	    return [];
	  }
	};

	getContactInfo = function(contact) {
	  if (contact == null) {
	    contact = {};
	  }
	  return {
	    avatar_url: contact.avatar,
	    full_name: Contacts.getFullName(contact),
	    contact_id: contact.id,
	    deceased: Profile.getDeceased(contact)
	  };
	};

	getInferredRelationshipType = function(main_contact, search_contact) {
	  var name, rel, rels, remote_id, type;
	  if (remote_id = getRemoteId(main_contact)) {
	    rels = parseRelationships(search_contact.relationships);
	    if (rel = _.findWhere(rels, {
	      remote_id: remote_id
	    })) {
	      type = rel.type;
	      name = getFirstName(main_contact);
	      if (type && name) {
	        return "Links " + name + " as '" + type + "'";
	      } else if (name) {
	        return "Links " + name + " as a relationship";
	      } else if (type) {
	        return "Links as '" + type + "'";
	      } else {
	        return "Links as a relationship";
	      }
	    }
	  }
	};

	formatRelationship = function(relationship, main_contact) {
	  var avatar_url, contact_id, deceased, full_name, inferred_type, is_inferred_contact, name, ref1, ref2, relationship_contact, remote_id, search_contact, type;
	  if (relationship == null) {
	    relationship = {};
	  }
	  if (main_contact == null) {
	    main_contact = {};
	  }
	  relationship_contact = relationship.relationship_contact, search_contact = relationship.search_contact, name = relationship.name, remote_id = relationship.remote_id, type = relationship.type;
	  is_inferred_contact = false;
	  if (relationship_contact) {
	    ref1 = getContactInfo(relationship_contact), avatar_url = ref1.avatar_url, full_name = ref1.full_name, contact_id = ref1.contact_id, deceased = ref1.deceased;
	  } else if (search_contact) {
	    is_inferred_contact = true;
	    ref2 = getContactInfo(search_contact), avatar_url = ref2.avatar_url, full_name = ref2.full_name, contact_id = ref2.contact_id, deceased = ref2.deceased;
	    inferred_type = getInferredRelationshipType(main_contact, search_contact);
	  }
	  return {
	    name: name || full_name,
	    type: type || inferred_type,
	    remote_id: remote_id,
	    avatar_url: avatar_url,
	    contact_id: contact_id,
	    contact_name: full_name,
	    relationship_name: name,
	    relationship_type: type,
	    deceased: deceased,
	    inferred_type: inferred_type,
	    is_inferred_contact: is_inferred_contact
	  };
	};

	module.exports = {
	  getRelationshipRemoteIds: function(contact) {
	    if (contact == null) {
	      contact = {};
	    }
	    return _.compact(_.map(contact.relationships, function(rel) {
	      var ref1;
	      return rel != null ? (ref1 = rel.remote_id) != null ? ref1.value : void 0 : void 0;
	    }));
	  },
	  getRemoteId: getRemoteId,
	  getRelationships: function(main_contact, relationship_contacts_resp, search_contacts_resp) {
	    var main_relationships, relationship_contacts, relationships_contacts_index, search_contacts;
	    if (main_contact == null) {
	      main_contact = {};
	    }
	    relationship_contacts = relationship_contacts_resp != null ? relationship_contacts_resp.items : void 0;
	    search_contacts = search_contacts_resp != null ? search_contacts_resp.items : void 0;
	    relationship_contacts = _.isArray(relationship_contacts) ? relationship_contacts : [];
	    search_contacts = _.isArray(search_contacts) ? search_contacts : [];
	    main_relationships = parseRelationships(main_contact.relationships);
	    relationships_contacts_index = indexByRemoteId(relationship_contacts);
	    _.each(main_relationships, function(relationship) {
	      var relationship_contact, remote_id;
	      if (remote_id = relationship.remote_id) {
	        if (relationship_contact = relationships_contacts_index[remote_id]) {
	          return relationship.relationship_contact = relationship_contact;
	        }
	      }
	    });
	    _.each(search_contacts, function(search_contact) {
	      var relationship, search_remote_id;
	      search_remote_id = getRemoteId(search_contact);
	      if (relationship = _.findWhere(main_relationships, {
	        remote_id: search_remote_id
	      })) {
	        return relationship.search_contact = search_contact;
	      } else {
	        return main_relationships.push({
	          search_contact: search_contact
	        });
	      }
	    });
	    main_relationships = _.sortBy(main_relationships, function(info) {
	      if (info.relationship_contact) {
	        return 0;
	      } else if (info.search_contact) {
	        return 1;
	      } else {
	        return 2;
	      }
	    });
	    return _.map(main_relationships, function(relationship) {
	      return formatRelationship(relationship, main_contact);
	    });
	  },
	  getSortedVMSRelationships: getSortedVMSRelationships,
	  getSortedRelationships: getSortedRelationships
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(2);

	var getSortedRelationships = function(contact, vals) {
	   if (contact.relationships) {
	      return _.reduce(
	         contact.relationships,

	         function(accum, rel) {
	            var tracker = [];
	            vals.forEach(function(val) {
	               var reg = new RegExp(val);
	               if (
	                  reg.test(
	                     rel &&
	                        rel.type &&
	                        rel.type.value &&
	                        rel.type.value.toLowerCase()
	                  )
	               ) {
	                  tracker.push(val);
	               }
	            });
	            if (tracker.length) accum.unshift(rel);
	            else accum.push(rel);
	            return accum;
	         },
	         []
	      );
	   }
	   return [];
	};

	var getSortedVMSRelationships = function(contact) {
	   var vals = ["spouse", "partner", "husband", "wife"];
	   return getSortedRelationships(contact, vals);
	};

	module.exports = {
	   getSortedRelationships: getSortedRelationships,
	   getSortedVMSRelationships: getSortedVMSRelationships
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var DEFAULT_FY, Giving, _, moment, warn;

	_ = __webpack_require__(2);

	moment = __webpack_require__(12);

	DEFAULT_FY = "07-01";

	warn = _.once(function() {
	  return console.warn("FY is not set, will use default (07-01) instead of org specific setting.");
	});

	Giving = function() {
	  var _getYears, _warnFY, api;
	  _warnFY = function(fy) {
	    if (!fy) {
	      return warn();
	    }
	  };
	  _getYears = function(fy) {
	    var current_fy, current_month, i, ref, results;
	    if (fy == null) {
	      fy = DEFAULT_FY;
	    }
	    current_fy = new Date().getFullYear();
	    current_month = new Date().getMonth();
	    if (current_month >= moment(fy, "MM-DD").month()) {
	      current_fy += 1;
	    }
	    return (function() {
	      results = [];
	      for (var i = current_fy, ref = current_fy - 6; current_fy <= ref ? i < ref : i > ref; current_fy <= ref ? i++ : i--){ results.push(i); }
	      return results;
	    }).apply(this);
	  };
	  return api = {
	    getVolunteerProfileGiving: function(pool, contact, fy) {
	      var giving, last_five_years, pool_category;
	      if (pool == null) {
	        pool = {};
	      }
	      if (contact == null) {
	        contact = {};
	      }
	      pool_category = pool.giving_category_label;
	      if (pool_category === "EverTrueNoData") {
	        return {};
	      } else {
	        giving = this.getCategoryGiving(contact, pool_category, fy);
	        last_five_years = _.map(_getYears(fy), function(year) {
	          return _.findWhere(giving.history, {
	            year: year
	          }) || {
	            year: year,
	            amount: null
	          };
	        });
	        giving.history = last_five_years;
	        return giving;
	      }
	    },
	    getProfileGiving: function(contact, fy) {
	      var giving_data, years;
	      if (contact == null) {
	        contact = {};
	      }
	      _warnFY(fy);
	      years = _getYears(fy);
	      giving_data = {};
	      _.each(contact.giving, function(prop) {
	        return giving_data[prop.name] = prop.value;
	      });
	      giving_data.history = _.sortBy(_.map(contact.giving_annual_donations, function(data) {
	        var ref, ref1;
	        return {
	          year: (ref = data.fiscal_year) != null ? ref.value : void 0,
	          amount: (ref1 = data.amount) != null ? ref1.value : void 0
	        };
	      }, "year")).reverse();
	      giving_data.categories = _.compact(_.map(contact.giving_categories, function(category) {
	        var category_obj, ref;
	        if ((ref = category.label) != null ? ref.value : void 0) {
	          category_obj = {
	            history: []
	          };
	          _.each(category, function(prop, key) {
	            var index, ref1, str;
	            if (!key.match("fiscal_year")) {
	              return category_obj[key] = prop != null ? prop.value : void 0;
	            } else {
	              ref1 = key.match(/^fiscal_year_([0-9])_amount$/), str = ref1[0], index = ref1[1];
	              index = parseInt(index, 10);
	              return category_obj.history.push({
	                year: years[index],
	                amount: prop != null ? prop.value : void 0
	              });
	            }
	          });
	          category_obj.history = _.sortBy(category_obj.history, "year").reverse();
	          return category_obj;
	        }
	      }));
	      return giving_data;
	    },
	    getCategoryGiving: function(contact, category, fy) {
	      var giving;
	      giving = this.getProfileGiving(contact, fy);
	      if (category) {
	        return _.findWhere(giving.categories, {
	          label: category
	        }) || {};
	      } else {
	        return _.omit(giving, "categories") || {};
	      }
	    },
	    getVolunteerHasGivenLastFY: function(pool, contact, fy) {
	      var history, ref;
	      if (pool == null) {
	        pool = {};
	      }
	      if (contact == null) {
	        contact = {};
	      }
	      history = (this.getVolunteerProfileGiving(pool, contact, fy) || {}).history;
	      if (history == null) {
	        history = [];
	      }
	      return Boolean((ref = history[0]) != null ? ref.amount : void 0);
	    },
	    getLastGiftDate: function(contact, format) {
	      var giving, last_gift_date;
	      if (contact == null) {
	        contact = {};
	      }
	      if (format == null) {
	        format = "MMM DD, YYYY";
	      }
	      giving = contact.giving || {};
	      last_gift_date = giving.last_gift_date || {};
	      if (last_gift_date.value) {
	        return moment(last_gift_date.value, "MM/DD/YYYY").format(format);
	      } else {
	        return null;
	      }
	    }
	  };
	};

	module.exports = Giving();


/***/ })
/******/ ])
});
;